(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mbc-core"] = factory();
	else
		root["mbc-core"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 115);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Base = __webpack_require__(6);
var Classes = __webpack_require__(8);
var Config = __webpack_require__(48);

/**
 * Canvas is in charge of create and calculate dimensions of the svg container where the chart is going to be rendered.
 * Also creates layers that holds chart's parts (axis, chart area, etc.)
 * @constructor
 * @param {D3.selection} container
 * @param {Object} margin
 */
var Canvas = Base.extend(
/**
 *  @lends Canvas.prototype
 **/
{
    /** @type {D3 selection} */
    selection: null,
    /** @type {Object} */
    margin: Config.canvasDefaults.margin,
    /** @type {Number} */
    axesSpacing: Config.canvasDefaults.axesSpacing,
    /** @type {Number} */
    axesPadding: 0,
    /** @type {DOM element} */
    container: null,
    /** @type {DOM element} */
    svg: null,
    /** @type {Number} */
    yAxesLabelWidth: 10,

    /**
     * Sets up the canvas object
     */
    initializer: function initializer() {
        var template = this.get("template");

        if (template && (typeof template === "string" || typeof template === "function")) {
            this.get("selection").html(template);
            this.set("container", this.get("selection").select("." + Classes.INNER)[0][0]);
            this.set("inner", true);
        } else {
            this.set("container", this.get("selection")[0][0]);
        }

        this.calculate();
        this.buildSVG();
    },

    /**
     * Update the canvas.
     * @return {Canvas} this Canvas object.
     */
    update: function update() {
        this.calculate();
        this.buildSVG();
        return this;
    },

    /**
     * Returns the width of chart inner container.
     * @return {Number} Inner container width.
     */
    width: function width() {
        return this.get("width");
    },

    /**
     * Returns the inner container height.
     * @return {Number} Inner container height.
     */
    height: function height() {
        return this.get("height");
    },

    /**
     * Returns the outer container width.
     * @return {Number} Outer container width.
     */
    outerWidth: function outerWidth() {
        return this.get("outerWidth");
    },

    /**
     * Returns the outer container height.
     * @return {Number} Outer container height.
     */
    outerHeight: function outerHeight() {
        return this.get("outerHeight");
    },

    /**
     * Calculates width and height of chart's area.
     */
    calculate: function calculate() {
        var selection = this.get("selection")[0][0];
        var container = this.get("container");
        var margin = this.get("margin");

        this.set("width", container.offsetWidth - margin.left - margin.right);
        this.set("height", container.offsetHeight - margin.top - margin.bottom);
        this.set("outerWidth", selection.offsetWidth);
        this.set("outerHeight", selection.offsetHeight);
    },

    /**
     * Appends the SVG Elements and set its dimensions.
     * @private
     */
    buildSVG: function buildSVG() {
        var svg = this.get("svg");
        var margin = this.get("margin");

        if (!svg) {
            svg = d3.select(this.get("container")).append("svg").attr("role", "chart").classed(Classes.CANVAS, true);
            this.set("svg", svg);
        }

        this.buildContainerGroups();
        svg.attrs({
            width: this.get("width") + margin.left + margin.right,
            height: this.get("height") + margin.top + margin.bottom
        });
    },

    /**
     * Build layered contaiers for each charts components in this order:.
     *
     * <li> Axes layer. </li>
     * <li> Behind chart layer. </li>
     * <li> Chart layer. </li>
     * <li> Front Chart layer. </li>
     * @private
     */
    buildContainerGroups: function buildContainerGroups() {
        var margin = this.get("margin");
        var svg = this.get("svg");
        var groups = svg.select("." + Classes.LAYERS);

        if (groups.empty()) {
            groups = svg.append("g").classed(Classes.LAYERS, true);

            this.set("axesGroup", groups.append("g").classed(Classes.AXES, true));
            this.set("backGroup", groups.append("g").classed(Classes.BACK, true));
            this.set("chartGroup", groups.append("g").classed(Classes.CHART_GROUP, true));
            this.set("frontGroup", groups.append("g").classed(Classes.FRONT, true));
        }

        groups.attrs({
            transform: "translate(" + margin.left + "," + margin.top + ")"
        });
    },

    /**
     * Returns a layer inside the chart area, if it does not exist creates it unless avoidCreate is true.
     *
     * @param {String} layerName
     * @param {String} groupName axes, back, front, chart.
     * @param {Boolean} avoidCreate
     * @returns {D3.Selection}
     */
    layer: function layer(layerName, groupName, avoidCreate) {
        groupName = (groupName || "chart") + "Group";
        var group = this.get(groupName);
        var layer = group.select("." + layerName);

        if (!avoidCreate && layer.empty()) {
            layer = group.append("g").classed(layerName, true);
        }

        return layer;
    },

    /**
     * Removes a layer inside the given group.
     *
     * @param {String} layerName
     * @param {String} groupName axes, back, front, chart.
     * @returns {D3.Selection}
     */
    removeLayer: function removeLayer(layerName, groupName) {
        groupName = (groupName || "chart") + "Group";
        var group = this.get(groupName);
        group.select("." + layerName).remove();
    },

    /**
     * Remove the old axes (if they exist) and add the new axes into the axes layer.
     *
     * @param {AxesManager} axesManager AxesManager containing updated axes.
     */
    drawAxes: function drawAxes(axesManager) {
        var axes = axesManager.axes();
        var axesCount = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        var axesGroup = this.get("axesGroup");
        var yAxesLabelWidth = this.get("yAxesLabelWidth");
        var axesSpacing = this.get("axesSpacing") + yAxesLabelWidth;
        var axesPadding = this.get("axesPadding");
        var key, axis, translate, orient, count, tickSize, calc;

        axesGroup.selectAll("." + Classes.AXIS).remove();
        for (key in axes) {
            var _axesGroup$append$cla;

            axis = axes[key];
            orient = axis.orient();
            count = axesCount[orient];
            tickSize = axis.tickSize();

            switch (orient) {
                case "bottom":
                    translate = "translate(0, " + this.get("height") + ")";
                    break;
                case "right":
                    calc = axesPadding + (this.get("width") + count * (axesSpacing + tickSize));
                    translate = "translate(" + calc + ", 0)";
                    break;
                case "top":
                    translate = "translate(0, 0)";
                    break;
                case "left":
                    calc = 0 - axesPadding - count * (axesSpacing + tickSize);
                    translate = "translate(" + calc + ", 0)";
                    break;
                default:
                    break;
            }
            axesCount[orient]++;
            axesGroup.append("g").classed((_axesGroup$append$cla = {}, _defineProperty(_axesGroup$append$cla, Classes.AXIS, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + key, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + orient, true), _axesGroup$append$cla)).attr("transform", translate).call(axis);
        }
    },
    /**
     * Removes the canvas from the container and reset the watchers object.
     */
    remove: function remove() {
        this.unwatchAll();
        this.get("selection").selectAll("*").remove();
    }
});

module.exports = Canvas;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var Utils = __webpack_require__(4);

/**
 * Creates a new DataManager instance.
 * @example
 * var dataManager = new DataManager();
 * @constructor
 */
function DataManager() {
    /**
     * @type {Array}
     * @private
     */
    this._data = [];
    /**
     * @type {Object}
     * @private
     */
    this._parsers = {};
    /**
     * @type {Number} Integer that holds the next index to assign
     * @private
     */
    this._nextIndex = 0;
}

/**
 * Gets all series attributes as parameters and returns a series object. This is intended to mantain legacy with previos versions.
 *
 * @param {String} seriesName Identifier for the series. Required.
 * @param {Array} series Array containing the series values. Required.
 * @param {String} groupName Identifier used to group series.
 * @param {Boolean} notIndexable If it is true the series is not indexed into the data manager.
 * @param {String} displayName String to be displayed.
 * @returns {Object} Series object
 */
function getSetAttributes(args) {
    var seriesName, series, groupName, notIndexable, displayName;
    seriesName = args[0];
    series = args[1];
    groupName = args[2];
    notIndexable = args[3];
    displayName = args[4];

    if (!seriesName || !series) {
        return;
    }

    return {
        name: seriesName,
        series: series,
        group: groupName,
        notIndexable: notIndexable,
        display: displayName
    };
}

/**
 * Recalculate indexed series indexes.
 *
 * @param {Array} data Array of series object.
 */
function recalcIndexes(data) {
    data.forEach(function (dataItem, i) {
        if (dataItem.index !== -1) {
            dataItem.index = i;
        }
    });
}

/**
 * Recalculate in-group indexes.
 *
 * @param {any} groupArray
 */
function recalcGroupIndexes(groupArray) {
    groupArray.forEach(function (item, i) {
        item.groupIndex = i;
    });
}

/**
 * Adds a series to the data manager. Receives an <i>Options Object</i> this way:
 * <br><br>
 * <code>
 * {
 *   name: "green_apples" // String
 *   series: [10, 20, 30, 40], // Array
 *   group: "Fruits",
 *   display: "Green Apples",
 *   notIndexable: false
 * }
 * </code>
 * <br>The <b>name</b> is the identifier for each series.
 * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
 * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
 * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
 * <br>If <b>notIndexable</b> is false, then the series is being indexed, non indexed series has index equals to -1.
 * <br><br>
 * For each series the datamanager creates a <i>Series Object</i> like:
 * <code>
 * {
 *   name: "green_apples",
 *   series: [10, 20, 30, 40],
 *   groupName: "Fruits",
 *   displayName: "Green Apples",
 *   index: 0,
 *   groupIndex: 0
 * }
 * </code>
 * @example
 * var dataManager = new DataManager();
 * // Minimal
 * dataManager.set({
 *   name: "Bar Chart Data",
 *   series: [40, 50, 60, 25]
 * });
 *
 * // If you need grouped data for a grouped bar chart for example.
 *
 * dataManager.set(
 *   name: "apples",
 *   display: "Apples",
 *   series: [25, 45, 43, 20],
 *   group: "grouped-bar-chart-data"
 * });
 *
 * dataManager.set({
 *   name: "oranges",
 *   display: "Oranges",
 *   series: [5, 20, 16, 27],
 *   group: "grouped-bar-chart-data"
 * });
 *
 * @param {Object} options Set of options.
 */
DataManager.prototype.set = function (options) {
    var groupName, groupIndex;
    if (!options) {
        return;
    }

    // For legacy purposes.
    if (typeof options === "string") {
        options = getSetAttributes(arguments);
        if (typeof options === "undefined") {
            return;
        }
    }

    groupName = options.group || options.name;
    groupIndex = this.queryGroup(groupName).length;

    this._data.push({
        name: options.name,
        series: options.series,
        groupName: groupName,
        displayName: options.display || options.name,
        index: !options.notIndexable ? this._nextIndex++ : -1,
        groupIndex: groupIndex,
        color: options.color
    });
};

/**
 * Unindexed Set, Same of set method but without set index to data, assing index = -1
 * Adds an unindexed series to the data manager. Receives an <i>Options Object</i> this way:
 * <br><br>
 * <code>
 * {
 *   name: "green_apples" // String
 *   series: [10, 20, 30, 40], // Array
 *   group: "Fruits",
 *   display: "Green Apples",
 * }
 * </code>
 * <br>The <b>name</b> is the identifier for each series.
 * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
 * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
 * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
 * @see set
 * @param {Object} options Set of options.
 */
DataManager.prototype.uset = function (options) {
    if (typeof options === "string") {
        options = getSetAttributes(arguments);
        if (typeof options === "undefined") {
            return;
        }
    }

    options.notIndexable = true;
    this.set(options);
};

/**
 * Update the series data specified by <i>seriesName</i>.
 * @example
 * dataManager.update("Apples", [2, 4, 6, 8]);
 * @param {String} seriesName Name of the series to update.
 * @param {Array} series Array of data to update.
 */
DataManager.prototype.update = function (seriesName, series) {
    var query = this._data.filter(function (series) {
        return series.name === seriesName;
    });

    var item;

    if (query.length) {
        item = query[0];
        item.series = series;
    }
};

/**
 * Removes a series from the data manager based on the series name.
 *
 * @param {String} seriesName Identifier of the series to remove.
 *
 * @return {Object} Removed Series Object.
 */
DataManager.prototype.remove = function (seriesName) {
    var index = Utils.array.indexOf(this._data, "name", seriesName);
    this._nextIndex = 0;
    var removed;
    if (index !== -1) {
        removed = this._data.splice(index, 1);

        // Recalculate general indexes
        recalcIndexes(this._data);

        // Recalculate group indexes
        recalcGroupIndexes(this.queryGroup(removed[0].groupName));
    }

    return removed;
};

/**
 * Resets the Datamanager.
 */
DataManager.prototype.clean = function () {
    this._data = [];
    this._parsers = {};
    this._nextIndex = 0;
};

/**
 * Search for the series in a determined group.
 *
 * @param {String} groupName Name of the group to search.
 * @returns {Array<Object>} Series in the group
 */
DataManager.prototype.queryGroup = function (groupName) {
    return this._data.filter(function (series) {
        return series.groupName === groupName;
    });
};

/**
 * If no parser is setted for the group then returns the raw data array from the store.
 * <br><br>
 * If parser is setted, then returns the data parsed by the function.
 *
 * @example
 * function parser(data, domain) {
 *   // data contains an array of series objects {}
 *   // domain is an argument
 *   var map = domain.map(function (point, i) {
 *       var obj = { point: point };
 *
 *       obj.values = data.map(function (value) {
 *           return {
 *               series: value.name,
 *               value: value.series[i]
 *           };
 *       });
 *       return obj;
 *   });
 *   return map;
 * }
 *
 * dataManager.parser("grouped-bar-chart-data", parser, ["Mon", "Tue", "Wed", "Thu"]);
 * var data = dataManager.get("grouped-bar-chart-data";
 * //  Resultingdata:
 * //  [{
 * //      point: "Mon",
 * //      values: {[
 * //          series: "Apples",
 * //          value: 25
 * //      ],[
 * //          series: "Oranges",
 * //          value: 5
 * //      ]...}
 * //  } ...]
 *
 * @param {any} groupName
 * @returns {Array} Array that contains data.
 */
DataManager.prototype.get = function (groupName) {
    if (!groupName) {
        return;
    }

    var data = this.queryGroup(groupName);
    var parser = this._parsers[groupName];
    var args;

    if (!parser) {
        return data;
    } else {
        args = [data].concat(parser.arguments);
        return parser.fn.apply(this, args);
    }
};

/**
 * Calculates the domain for the groups in _groupArray_, if not _groupArray_ is specified calculates for all data in the store.
 * <br><br>
 * Also rounds the domains to the nearest tenth (by default) or by the value specified in _roundDomainTo_.
 * @example
 * // There are 3 data groups: datagroup-1, datagroup-2 and datagroup-3.
 *
 * // Calculates domain only for groups datagroup-1 and datagroup-3.
 * var domain = dataManager.calculateDomain({
 *    groups: ["datagroup-1", "datagroup-2"]
 * });
 *
 * // Calculates domain for all groups.
 * var domain = dataManager.calculateDomain();
 *
 * // Calculates domain for all groups and round it to hundreds.
 * var domain = dataManager.calculateDomain({
 *  roundTo: 100
 *});
 *
 * // Calculates domain only for datagroup-3 and round it to hundreds.
 * var domain = dataManager.calculateDomain({
 *   groups: ["datagroup-3"],
 *   roundTo: 1000
 * });
 * @param {Object}? options Options available:
 * <li><b>groups:</b> Optional. Array of names of the data groups to include in the domain calculation.
 * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
 * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
 * <li><b>symmetrical:</b> Optional.
 * <li><b>steps:</b> Optional. Intended ticks number.
 * <li><b>accessor:</b> Optional. To access data.
 * <li><b>raw:</b> Optional. Force the domain calculation using unrounded values.
 *
 * @returns {Array} An array of length 2 with the calculated domain
 */
DataManager.prototype.calculateDomain = function (options) {
    options = options || {};
    var _this = this;
    var values = [];
    var groupArray = options.groups;
    var domainOptions = {
        forceNegative: options.forceNegative,
        symmetrical: options.symmetrical,
        steps: options.steps,
        integers: options.integers,
        raw: options.raw
    };

    // If not defined get all groups
    if (!groupArray) {
        groupArray = Utils.array.removeDuplicates(this._data.map(function (data) {
            return data.groupName;
        }));
    }

    groupArray.forEach(function (group) {
        var query = _this.queryGroup(group);
        var series;

        var accessorMap = function accessorMap(item, accessor) {
            return item.series.map(function (d) {
                return Utils.object.extract(d, accessor);
            });
        };

        if (options.stacked) {
            series = query.map(function (item) {
                if (options.accessor) {
                    return accessorMap(item, options.accessor);
                } else {
                    return item.series;
                }
            });

            values = values.concat(Utils.array.getStackedValues(series));
        } else {
            query.forEach(function (item) {
                if (options.accessor) {
                    values = values.concat(accessorMap(item, options.accessor));
                } else {
                    values = values.concat(item.series);
                }
            });
        }
    });

    // check values
    values = values.map(function (value) {
        return typeof value !== "undefined" ? value : 0;
    });

    var min = d3.min(values);
    var max = d3.max(values);
    var highest;
    var forceNegative = options.forceNegative;

    if (min === 0 && max === 0) {
        return forceNegative ? [-1, 1] : [0, 1];
    }

    if (max % 10 === 0) {
        values.push(max + 10);
    }

    if (min < 0 && min % 10 === 0) {
        values.push(min - 10);
    }

    if (typeof options.roundTo === "number") {
        domainOptions.roundTo = options.roundTo;
    } else if (min > -1 && max < 1) {
        return min < 0 || forceNegative ? [-1, 1] : [0, 1];
    } else if (max < 10 && min > -10) {
        highest = Math.max(Math.abs(min), Math.abs(max));
        domainOptions.roundTo = highest % 2 === 0 ? highest % 6 === 0 ? 4 : 3 : 2;
    } else {
        domainOptions.roundTo = Utils.array.getRoundToUnits(values);
    }

    domainOptions.values = values;
    return Utils.chart.getDomain(domainOptions);
};

/**
 * Sets a parser (formatter) function for a determined group of data. If arguments are passed they are passed too to the parser function as parameters.
 *
 * @param {any} groupName
 * @param {any} parser
 * @returns {Function} If only one argument is passed
 */
DataManager.prototype.parser = function (groupName, parser) {
    var newParser;
    if (!groupName) {
        return;
    }

    if (!parser) {
        return this._parsers[groupName];
    }

    newParser = {};
    newParser.fn = parser;
    newParser.arguments = Array.prototype.slice.call(arguments, 2);

    this._parsers[groupName] = newParser;
    return parser;
};

/**
 * Returns all data combined
 * @example
 *  dataManager.set("Cars", [10, 20], "vehicles");
 *  dataManager.set("Planes", [30, 40], "vehicles");
 *  dataManager.set("Tricycle", [5, 15], "tricycle");
 *
 *  dataManager.combine("tricycle")
 *  dataManager.combine(["vehicles", "tricycle"])
 *
 * @param {Array|String} groupNames The name of a group name or an array containing all group names you want to get data combined.
 * @return {Array} Data combined.
 */
DataManager.prototype.combine = function (groupNames) {
    var metadataArray = [];
    var seriesArray = [];
    var combined = [];
    var i = 0;
    var j = 0;
    var len, pointObj, seriesLength, metadata, value;
    groupNames = typeof groupNames === "string" ? [groupNames] : groupNames;
    groupNames.forEach(function (seriesObject) {
        this.queryGroup(seriesObject).forEach(function (point) {
            seriesArray.push(point.series);
            metadataArray.push({
                name: point.name,
                groupName: point.groupName,
                displayName: point.displayName,
                index: point.index,
                groupIndex: point.groupIndex
            });
        });
    }.bind(this));

    len = seriesArray[0].length;
    seriesLength = seriesArray.length;

    for (; i < len; i++) {
        pointObj = [];
        j = 0;
        for (; j < seriesLength; j++) {
            value = seriesArray[j][i];
            metadata = metadataArray[j];
            pointObj.push({
                name: metadata.name,
                groupName: metadata.groupName,
                displayName: metadata.displayName,
                index: metadata.index,
                value: value,
                groupIndex: metadata.groupIndex
            });
        }

        combined.push(pointObj);
    }

    return combined;
};

/**
 * Returns <b>true</b> if a series is contained in a give group.
 * @param {String} seriesName
 * @param {String} groupName
 * @returns {Boolean}
 */
DataManager.prototype.inGroup = function (seriesName, groupName) {
    var group = this.queryGroup(groupName);
    var len = group.length;
    var i;

    for (i = 0; i < len; i++) {
        if (group[i].name === seriesName) {
            return true;
        }
    }

    return false;
};

module.exports = DataManager;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Creates a new ScaleManager instance.
 *
 * @constructor
 * @param {Object} scales
 */

function ScaleManager(scales) {
    this._scales = scales || {};
}

/**
 * Sets a new scale, if no <i>scale</i> is passed then returns the scale object.
 *
 * @param {String} scaleName Name for the scale.
 * @param {D3.scale} scale
 * @returns {D3.scale}
 */
ScaleManager.prototype.scale = function (scaleName, scale) {
    if (!scaleName) {
        return;
    }

    if (!scale) {
        return this._scales[scaleName];
    }

    this._scales[scaleName] = scale;
};

/**
 * Sets the scale's domain, if no <i>domain</i> is passed returns it.
 *
 * @param {String} scaleName
 * @param {Array} domain
 * @returns {Array} Domain for a specific scale.
 */
ScaleManager.prototype.domain = function (scaleName, domain) {
    if (!scaleName) {
        return;
    }

    if (!domain) {
        return this._scales[scaleName].domain();
    }

    this._scales[scaleName].domain(domain);
};

/**
 * Sets the scale's range, if no _range_ is passed returns it.
 *
 * @param {String} scaleName
 * @param {Array} range
 * @returns Range for a specific scale.
 */
ScaleManager.prototype.range = function (scaleName, range) {
    if (!scaleName) {
        return;
    }

    if (!range) {
        return this._scales[scaleName].range();
    }

    this._scales[scaleName].range(range);
};

/**
 * Remove a scale from the hashmap.
 * @param {String} scaleName Scale to remove.
 */
ScaleManager.prototype.remove = function (scaleName) {
    delete this._scales[scaleName];
};

module.exports = ScaleManager;

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @module Core */

var AxesManager = __webpack_require__(9);
var Canvas = __webpack_require__(10);
var Chart = __webpack_require__(37);
var DataManager = __webpack_require__(11);
var Base = __webpack_require__(6);
var ScalesManager = __webpack_require__(12);
var Utils = __webpack_require__(4);
var Classes = __webpack_require__(8);
var d3Overrides = __webpack_require__(49);
var version = __webpack_require__(50);
var Axes = __webpack_require__(39);

// D3 overrides
d3Overrides();
// Sets MBC version on window
version();

module.exports = {
  /**
   * @see AxesManager
   */
  AxesManager: AxesManager,
  /**
   * @see Canvas
   */
  Canvas: Canvas,
  /**
   * @see Chart
   */
  Chart: Chart,
  /**
   * @see Base
   */
  Base: Base,
  /**
   * @see ScalesManager
   */
  ScalesManager: ScalesManager,
  /**
   * @see DataManager
   */
  DataManager: DataManager,
  /**
  * @see Utils
  */
  Utils: Utils,
  /**
   * @see Classes
   */
  Classes: Classes,
  /**
  * @see Axes
  */
  Axes: Axes
};

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extract = __webpack_require__(3).extract;
/**
 * Returns true if an array contains just null values. If the parameter is a falsey value returns undefined.
 * @example
 * Util.array.hasNulls([null, null, null]) // returns true
 *  @param {Array} arr Array to inspect.
 * @return {Boolean} true means that the array contains null values.
 **/
var hasNulls = function hasNulls(arr) {
    if (!arr) return;
    var len = arr.length;
    var i = 0;
    for (; i < len; i++) {
        if (arr[i] !== null) {
            return false;
        }
    }

    return true;
};

/**
 * Returns false if the array passed contains negative values.
 *
 * @param {Array<Number>} allValues Numeric array.
 * @return {Boolean} Boolean indicating if the array contains at least one negative value.
 */
var hasNegative = function hasNegative(allValues) {
    if (!allValues) return;
    return d3.min(allValues) < 0;
};

/**
 * Return a new array with absolute numbers.
 * @param {Array<Number>} allValues Input array of numbers.
 */
var getAllPositives = function getAllPositives(allValues) {
    return allValues.map(function (val) {
        return Math.abs(val);
    });
};

/**
 * Rmoves duplicates from an array.
 *
 * @export
 * @param {Array} array Source array.
 * @returns {Array} Array without duplicates.
 */
var removeDuplicates = function removeDuplicates(array) {
    if (!array) return;
    return array.filter(function (elem, index, _this) {
        return index === _this.indexOf(elem);
    });
};

var indexOf = function indexOf(array, property, search) {
    var i, len;
    for (i = 0, len = array.length; i < len; i++) {
        if (array[i][property] === search) return i;
    }

    return -1;
};

/**
 * Returns and array with all values stacked by index, it includes negative and positive values
 * @param {Array} arrays Array of arrays containig series values.
 * @return {Array} Array with all values.
 */
var getStackedValues = function getStackedValues(arrays) {
    var i = 0;
    var j = 0;
    var arrLength = arrays.length;
    var length = -1;
    var positive = 0;
    var negative = 0;
    var stacked = [];
    var actualLength, value;

    // Check array lengths
    for (; i < arrLength; i++) {
        actualLength = arrays[i].length;
        if (length !== -1 && actualLength !== length) {
            throw new Error("Arrays must have the same length");
        }

        length = actualLength;
    }

    i = 0;
    for (; i < length; i++) {
        for (; j < arrLength; j++) {
            value = arrays[j][i];
            if (value >= 0) {
                positive += value;
            } else {
                negative += value;
            }
        }

        stacked.push(Math.round(positive));
        if (negative !== 0) stacked.push(Math.round(negative));
        positive = 0;
        negative = 0;
        j = 0;
    }

    return stacked;
};

/**
 * It searches for the min and max value inside an array.
 *
 * @param {any} array
 * @param {any} accesor
 * @returns Object
 */
function minmax(array, accesor) {
    var len = array.length;
    var i = 0;
    var obj, value, min, max, minValue, maxValue;
    for (; i < len; i++) {
        obj = array[i];
        value = extract(obj, accesor);

        if (typeof minValue === "undefined" || value < minValue) {
            minValue = value;
            min = array[i];
        }

        if (typeof maxValue === "undefined" || value > maxValue) {
            maxValue = value;
            max = array[i];
        }
    }

    return { min: min, max: max };
}

/**
 * It returns the thousandths, hundredths, tenths, hundred, thousands to round the domain.
 *
 * @param {Number[]} array Array of numbers.
 * @return {Number} 0.001, 0.01, 0.1, 1, 10, 100, 1000, ...
 */
function getRoundToUnits(array) {
    if (!array || !array.length) return 1;
    var absMean = d3.mean(array, function (d) {
        return Math.abs(d);
    });

    if (absMean === 0) return 1;
    if (absMean >= 1) {
        absMean = Math.ceil(absMean / 10);
        return Math.pow(10, ("" + absMean).length);
    } else {
        var decimals = ("" + absMean).split(".")[1];
        var match = decimals.match(/[^0]/);
        return 1 / Math.pow(10, match.index + 1);
    }
}

module.exports = {
    getAllPositives: getAllPositives,
    getRoundToUnits: getRoundToUnits,
    getStackedValues: getStackedValues,
    hasNegative: hasNegative,
    hasNulls: hasNulls,
    indexOf: indexOf,
    minmax: minmax,
    removeDuplicates: removeDuplicates
};

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(96);

var _core = __webpack_require__(13);

var _core2 = _interopRequireDefault(_core);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module Core */

module.exports = _core2.default;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Given a path it extract a value from a complex deep object.
 *
 * @param {Object} obj
 * @param {String} path
 * @returns Object's value found in the given path.
 */

function getPath(obj, path) {
    var index, prefix, subpath;
    if (!obj || !path || typeof path !== "string" || path === "") {
        return;
    }

    index = path.indexOf(".");
    if (index === -1) {
        return obj[path];
    } else {
        prefix = path.substring(0, index);
        subpath = path.substring(index + 1);
        return getPath(obj[prefix], subpath);
    }
}

/**
 * Copy source object properties into a target one.
 *
 * @export
 * @param {Object} target Target object.
 * @param {Object} source Source Object
 */
var copy = function copy(target) {
    var key, source;

    if (!target) {
        return;
    }

    for (var i = 1; i < arguments.length; i++) {
        source = arguments[i];
        for (key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

/**
 * Extracts a value using an accessor or the same value if no accessor.
 * @param {Object} item Contains the value.
 * @param {Function|String}? accessor Accesor function or field that contains the value.
 * @param {Object} params Parameters to pass to the accesor function.
 * @return {Object} Value.
 */
var extract = function extract(item, accessor, params) {
    var value;
    if (typeof accessor === "undefined") {
        value = item;
    } else if (typeof accessor === "function") {
        value = accessor(item, params);
    } else if (typeof accessor === "string") {
        value = item[accessor];
    }

    return value;
};

/**
 * Clones and object.
 *
 * @export
 * @param {Object} target Object toclone.
 * @returns {Object} Cloned object.
 */
var clone = function clone(target) {
    if (target === undefined || target === null) {
        throw new TypeError("Cannot convert first argument to object");
    }

    var to = Object(target);
    for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
            continue;
        }

        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
                to[nextKey] = nextSource[nextKey];
            }
        }
    }

    return to;
};

/**
 * If just the value is passed return a boolean indicated is the value is undefined.
 * If the second parameter exists if value is undefined retunrs the second parameter, if not returns the value.
 * @param {Obect} value Object to evaluate.
 * @param {Object} defaultValue Object to return in case vale¡ue is undefined.
 */
var isUndefined = function isUndefined(value, defaultValue) {
    if (typeof defaultValue !== "undefined") return typeof value === "undefined" ? defaultValue : value;else return typeof value === "undefined";
};

/**
 * Check if the given value is not a number then return null, if it is a number return the number.
 * @param {Object} val Value to check.
 * @returns {undefined|Number}
 */
var NaNtoNull = function NaNtoNull(val) {
    if (typeof val !== "number" || isNaN(val) || val === Infinity) {
        return null;
    } else {
        return val;
    }
};

/**
 * Method to get the boolean value, if not it returnd a default value.
 * @param {Object} value Value to check if it is a boolean.
 * @param {Boolean} defaultValue Default value in case value is not a boolean.
 * @returns {Boolean}
 */
var getBoolean = function getBoolean(value, defaultValue) {
    return typeof value === "boolean" ? value : defaultValue;
};

var assign = function assign(target) {
    // .length of function is 2
    if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
};

module.exports = {
    clone: clone,
    copy: copy,
    extract: extract,
    getBoolean: getBoolean,
    isUndefined: isUndefined,
    NaNtoNull: NaNtoNull,
    path: getPath,
    assign: assign
};

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AxesManager = __webpack_require__(9);
var Base = __webpack_require__(6);
var Canvas = __webpack_require__(10);
var DataManager = __webpack_require__(11);
var ScalesManager = __webpack_require__(12);
var Utils = __webpack_require__(4);
var Classes = __webpack_require__(8);

/**
 * A foundation for all axed charts.
 * The renderng cycle is:
 * <em><br>0- setData() Data is initialized.
 * <br>1- beforeDraw() method is called. Event <i>beforeDraw</i> is triggered.
 * <br>2- draw() method is called.
 * <br>3- afterDraw() method called. Event <i>afterDraw</i> is triggered.</em>
 * <br><br><small>Methods setData() and draw() MUST be implemented</small>
 * @example
 * var BarChart = Chart.extend({
 *  ...
 * })
 * @param {Object} options
 * @class
 * @extends Base
 */
var Chart = Base.extend(
/**
 * A foundation for all axed charts.
 *  @lends Chart.prototype
 **/
{
    /** @type {String} */
    UID: null,
    /** @type {AxisManager} */
    axes: null,
    /** @type {Canvas} */
    canvas: null,
    /** @type {DataManager} */
    data: null,
    /** @type {Array} */
    colors: Utils.colors.combined,
    /** @type {D3.dispatch} */
    dispatch: null,
    /** @type {ScaleManager} */
    scales: null,
    /** @type {Object} */
    margins: { top: 20, right: 40, bottom: 30, left: 40 },
    /** @type {String} */
    canvasTemplate: null,
    /** @type {Number} */
    yAxesLabelWidth: 0,
    /** @type {String} */
    legendPopoverParentElement: 'body', // pass string selector id including # (e.g. '#line-chart-container') or class including . (e.g. '.mbc-line-chart') of element to append popover

    /**
     * Initializes the chart.
     */
    initializer: function initializer() {
        this.set("UID", "mbc" + Utils.string.UID());
        this.set("axes", new AxesManager());
        this.set("data", new DataManager());
        this.set("dispatch", d3.dispatch("hover", "click", "afterDraw", "beforeDraw", "mouseout"));
        this.set("scales", new ScalesManager());
        d3.rebind(this, this.get("dispatch"), "on");
    },

    /**
     * Returns the function D3 calls to set the data.
     * @example
     * container.datum(dataset).call(chart.init());
     *
     * @returns {Function}
     */
    init: function init() {
        return this._createChart.bind(this);
    },
    /**
     * Adds a new Canvas object and calls the _prepare function for each selection
     * @param {D3.Selection} name Selection where the charts are going to be created.
     * @private
     */
    _createChart: function _createChart(selection) {
        var _selection$classed;

        this.set("selection", selection);
        selection.classed((_selection$classed = {}, _defineProperty(_selection$classed, this.get("id") || "", true), _defineProperty(_selection$classed, this.get("UID"), true), _selection$classed));
        this._createCanvas();
        selection.each(this._prepare.bind(this));
    },

    /**
     * Create and set a new canvas instance.
     */
    _createCanvas: function _createCanvas() {
        var selection = this.get("selection");
        // beforeCanvas method is called if exists.
        Utils.fn.call(this, this.beforeCanvas, selection);
        this.set("canvas", new Canvas({
            selection: selection,
            margin: this.get("margins"),
            template: this.get("canvasTemplate"),
            yAxesLabelWidth: this.get("yAxesLabelWidth"),
            UID: this.get("UID")
        }));
    },

    /**
     * Calls the setData or/and setup function if they exist and calls the rendering cycle if the data is valid.
     * @private
     */
    _prepare: function _prepare(data) {
        var invalidData = false;
        invalidData = Utils.fn.call(this, this.setup, data);
        /* FIXME: remove setData call next major version */
        invalidData = invalidData || Utils.fn.call(this, this.setData, data);
        if (!invalidData) this.update();
    },

    /**
     * Executes the rendering cycle in this order
     * <li> beforeDraw
     * <li> draw
     * <li> afterDraw
     */
    update: function update(options) {
        this.get("dispatch").beforeDraw();
        var updateCanvas = Utils.fn.call(this, this.beforeDraw, options);
        if (typeof updateCanvas === "undefined" || updateCanvas) this.get("canvas").update();
        this.draw(options);
        Utils.fn.call(this, this.afterDraw, options);
        this.get("dispatch").afterDraw();
    },

    /**
     * Returns the index *n* color from the *colors* attribute array
     * @param {Number} index Index of color to return
     */
    color: function color(index) {
        var colors = this.get("colors");
        return colors[index % colors.length];
    },

    /**
     * Returns a closure function with a formatter within.
     * @param {Function|String} format If it is a string uses d3.format.
     */
    tickFormat: function tickFormat(format) {
        return function (d, i) {
            if (!format) {
                return d;
            }

            return typeof format === "function" ? format(d, i) : d3.format(format)(d);
        };
    },

    /**
     * @abstract
     * @deprecated Use setup method instead.
     * Prepare the data for the chart and all the initial values prior to start rendering. Legacy.
     */
    setData: function setData() {},

    /**
     * @abstract
     * Prepare the data for the chart and all the initial values prior to start rendering.
     */
    setup: function setup() {},

    /**
     * @abstract
     * This method is called before creating the canvas instance, is useful to change the template before.
     */
    beforeCanvas: function beforeCanvas() {},

    /**
     * @abstract
     * This method is called before drawing the chart. Useful to prepare data when the SVG element is already inserted into the dom.
     */
    beforeDraw: function beforeDraw() {},

    /**
     * @abstract
     * Used to draw the chart into the SVG element.
     */
    draw: function draw() {
        console.error(new Error("draw method is not defined"));
    },

    /**
     * @abstract
     * Called after the chart is rendered. Useful to make post-render modifications.
     */
    afterDraw: function afterDraw() {},

    /**
     * Returns an id based class.
     * @param {String} suffix Suffix to add to the id.
     * @return {String} The class name (id + suffix).
     */
    getId: function getId(suffix) {
        return this.get("id") + "-" + suffix;
    },

    /**
     * @adjustYLabels
     * Visual adjustments after the chart has been rendered
     * appendYAbbreviation and adjustYAxisLabel
     */
    adjustYLabels: function adjustYLabels() {
        var axes = this.get("canvas").get("axesGroup");

        axes.selectAll(".x-alternative-first, .x-alternative-last").remove();

        axes.selectAll("." + Classes.AXIS + "-left .tick text, ." + Classes.AXIS + "-right .tick text").attrs({ x: 0, y: 12 });

        var y1Ticks = axes.selectAll("." + Classes.AXIS + "-y1 .tick");
        y1Ticks.first().classed("dark", true).select("text").attr("y", -10);

        y1Ticks.last().classed("dark", true);

        var y2Ticks = axes.selectAll("." + Classes.AXIS + "-y2 .tick");
        y2Ticks.first().classed("dark", true).select("text").attr("y", -10);

        y2Ticks.last().classed("dark", true);

        var y1TicksAlign = this.get("y1TicksAlign");
        var y1AxisOrient = this.get("y1AxisOrient");
        var y1Texts = axes.selectAll("." + Classes.AXIS + "-y1 text");
        if (y1TicksAlign === "right" && y1AxisOrient === "right") {
            y1Texts.attr("x", this.get("yTickSize")).style("text-anchor", "end");
        }

        if (y1TicksAlign === "left" && y1AxisOrient === "left") {
            y1Texts.attr("x", this.get("yTickSize") * -1).style("text-anchor", "start");
        }

        if (this.get("y2TicksAlign") === "right" && this.get("y2AxisOrient") === "right") {
            axes.selectAll("." + Classes.AXIS + "-y2 text").attr("x", this.get("yTickSize")).style("text-anchor", "end");
        }

        this.appendYAbbreviation(axes);

        this.adjustYAxisLabel("y1");
        if (this.get("y2")) {
            this.adjustYAxisLabel("y2");
        }
    },

    /**
     * Appends Y axes abbreviations under the up most tick.
     * Checks for 'y1Abbreviation' and 'y2Abbreviation.
     */
    appendYAbbreviation: function appendYAbbreviation(axes) {
        var appendAbbrev = function appendAbbrev(tick, abbrev, align) {
            var lastText = tick.select("text");
            tick.append("text").attrs({
                "text-anchor": align === "right" ? "end" : "start",
                x: lastText.attr("x"),
                y: lastText.attr("y") * 2 + 4,
                dy: lastText.attr("dy")
            }).classed("mbc-tick-abbreviation", true).text(abbrev);
        };

        var lastTick, textAlign;
        var y1Abbrev = this.get("y1Abbreviation"),
            y2Abbrev = this.get("y2Abbreviation");
        if (y1Abbrev) {
            lastTick = axes.selectAll("." + Classes.AXIS + "-y1 .tick").last();
            textAlign = this.get("y1TicksAlign");
            appendAbbrev(lastTick, y1Abbrev, textAlign);
        }

        if (this.get("y2") && y2Abbrev) {
            lastTick = axes.selectAll("." + Classes.AXIS + "-y2 .tick").last();
            textAlign = this.get("y2TicksAlign");
            appendAbbrev(lastTick, y2Abbrev, textAlign);
        }
    },

    /**
     * @adjustYAxisLabel
     * dynamic hide Y labels to avoid overlap
     * @param {String} yAxisName: "y1" or "y2"
     */
    adjustYAxisLabel: function adjustYAxisLabel(yAxisName) {
        var axes = this.get("canvas").get("axesGroup"),
            tickValues = this.get("axes").axis(yAxisName).tickValues(),
            axesTicks = axes.selectAll("." + Classes.AXIS + "-" + yAxisName + " .tick"),
            textSpacing = 23; // the height of tick text(18 + 0.32em)

        var lastPosition = 0,
            beforeLastPosition = 0,
            beforeLastShowedTickIndex = 0,
            lastShowedTickIndex = 0,
            showLastShowedTick = true,
            showBeforeLastShowedTick = true;

        axesTicks.style({
            opacity: function opacity(d, i) {
                var opacity = 0;
                var tickPosition = d3.transform(this.getAttribute("transform")).translate[1];
                var textTotalDy = parseFloat(this.lastChild.attributes.dy.value) * (this.childNodes.length - 1) * 14;
                var textDistance = +this.lastChild.attributes.y.value + textTotalDy;
                var currentPosition = tickPosition + textDistance;
                var distance = Math.abs(currentPosition - lastPosition);
                if (distance > textSpacing) {
                    opacity = 1;
                    beforeLastShowedTickIndex = lastShowedTickIndex;
                    lastShowedTickIndex = i;
                    beforeLastPosition = lastPosition;
                    lastPosition = currentPosition;
                }

                if (i === tickValues.length - 1 && opacity === 0) {
                    opacity = 1;
                    showLastShowedTick = false;
                    if (Math.abs(currentPosition - beforeLastPosition) < textSpacing) {
                        showBeforeLastShowedTick = false;
                    }
                }
                return opacity;
            }
        });

        if (!showLastShowedTick && showLastShowedTick !== 0) {
            d3.select(axesTicks[0][lastShowedTickIndex]).style({ opacity: 0 });
        }

        if (!showBeforeLastShowedTick && beforeLastShowedTickIndex !== 0) {
            d3.select(axesTicks[0][beforeLastShowedTickIndex]).style({ opacity: 0 });
        }
    },

    /**
     * Appends a Y axis label.
     * @param {Object} layer: "y1" or "y2"
     * @param {String} axisName: "y1" or "y2"
     * @param {String} text: y1AxisLabel or y2AxisLabel
     */
    appendYLabel: function appendYLabel(layer, axisName, text) {
        var yTickSize = this.get("yTickSize");
        var canvas = this.get("canvas");
        var axis = this.get("axes").axis(axisName);
        var isLeft = axis.orient() === "left";
        var axisSelector = Classes.AXIS + "-" + axisName;
        var anchor = isLeft ? "start" : "end";
        var rotation = isLeft ? 270 : 90;
        var axisLayer, translate, x, y, yLabel, svgText;
        var yAxesLabelPadding = this.get("yAxesLabelPadding");

        // Calculating
        axisLayer = canvas.layer(axisSelector, "axes", true);
        translate = d3.transform(axisLayer.attr("transform")).translate;
        x = isLeft ? translate[0] - yAxesLabelPadding - yTickSize : translate[0] + yTickSize + yAxesLabelPadding;
        y = canvas.height();

        yLabel = layer.append("g").attr(axisSelector + "-label", "axes").attr("transform", "translate(" + x + ", " + y + ")");

        svgText = yLabel.append("text").text(text).classed(axisSelector + "-label-text", "true").classed("mbc-y-axis-text", "true").attrs({
            "text-anchor": anchor,
            transform: "rotate(" + rotation + ")"
        });

        // dynamic abbreviate yAxisLabel if it is higher than container
        var labelText = svgText[0][0];
        var textHeight = Math.abs(labelText.clientWidth);
        if (textHeight > y) {
            var maxNum = Math.floor(y / (textHeight / text.length));
            labelText.innerHTML = text.substr(0, maxNum - 2) + "...";
        }
    }
});

module.exports = Chart;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(13);
var Utils = __webpack_require__(4);
var Base = __webpack_require__(6);

var DateAxis = Base.extend({
    /*axis data*/
    domain: [],
    range: [0, 0],
    subLabels: [],

    /*axis style*/
    orient: 'bottom',
    labelSpacing: 10,
    font: '14px helvetica neue',
    rangeBandsPadding: 0.00,
    rangeBandsOuterPadding: 0.00,

    /*label format*/
    labelFormat: '%b',
    subLabelFormat: '%Y',
    subLabelDx: '-0.75em',
    tickFormat: null,

    timeLevel: 'monthly',

    //======================= initialize ==========================

    initializer: function initializer() {
        this._initData();
        this._initScale();
        this._initAxis();
    },

    _initData: function _initData() {

        var opDomain = this.get('domain');
        var labelInterval = this._calcLabelInterval();
        var subLabels = this._calcSubLabels(opDomain, labelInterval);

        this.set('labelInterval', labelInterval);
        this.set('subLabels', subLabels);

        //temporary handle way, will set a map to contain yearly, quarterly, monthly
        var timeLevel = this.get('timeLevel').toLowerCase();
        switch (timeLevel) {
            case 'quarterly':
                this.set('tickFormat', this.quarterlyTickFormat);
                this.set('subLabelDx', '-0.5em');
                break;

            case 'yearly':
                this.set('tickFormat', d3.time.format('%Y'));
                this.set('subLabels', []);
                break;

            default:
                this.set('tickFormat', d3.time.format(this.get('labelFormat')));
                break;
        }
    },

    _initScale: function _initScale() {
        var domain = this.get('domain'),
            range = this.get('range');

        var scale = d3.scale.ordinal().domain(domain).rangeBands(range, this.get('rangeBandsPadding'), this.get('rangeBandsOuterPadding'));

        this.set('scale', scale);
    },

    _initAxis: function _initAxis() {
        var scale = this.getScale(),
            orient = this.get('orient'),
            formatFun = this.get('tickFormat'),
            labelInterval = this.get('labelInterval'),
            getDate = this.getDate;

        var axis = d3.svg.axis().scale(scale).orient(orient).tickFormat(function (d, i) {

            if (i % labelInterval !== 0) {
                return '';
            }

            if (typeof formatFun === 'function') {
                return formatFun(getDate(d));
            }

            return d;
        });

        this.set('axis', axis);
    },

    _calcLabelInterval: function _calcLabelInterval() {
        var opDomain = this.get('domain'),
            range = this.get('range'),
            axisWidth = range[1] - range[0],
            spacing = this.get('labelSpacing'),
            labelFormat = d3.time.format(this.get('labelFormat')),
            getDate = this.getDate,
            maxTextWidth,
            maxLabelCount,
            labelInterval;

        maxTextWidth = this.calcMaxTextWidth(opDomain.map(function (item) {
            return labelFormat(getDate(item));
        }));

        //maxText * n + spacing * (n-1) < width;
        maxLabelCount = Math.floor((axisWidth + spacing) / (maxTextWidth + spacing));

        labelInterval = Math.ceil(opDomain.length / maxLabelCount);

        return labelInterval;
    },

    _calcSubLabels: function _calcSubLabels(domain, labelInterval) {
        if (!Array.isArray(domain)) {
            return [];
        }

        var subLabels = [];
        var timeFormat = d3.time.format;
        var subLabelFormat = timeFormat(this.get('subLabelFormat'));
        var getDate = this.getDate;

        domain.forEach(function (item, index) {
            var date = getDate(item);
            var label = subLabelFormat(date);

            if (index % labelInterval === 0 && subLabels.indexOf(label) === -1) {
                subLabels.push(label);
            } else {
                subLabels.push(null);
            }
        });

        return subLabels;
    },

    //======================== public methods ======================

    draw: function draw(selection) {
        var axis = this.getAxis();
        selection.call(axis);
    },

    drawSubLabels: function drawSubLabels(canvas) {
        var xScale = this.get("scale");
        var xAxisOrient = this.get("orient");
        var subLabels = this.get("subLabels");
        var xlayer = canvas.layer("mbc-axes-xlabels", "axes");
        var xTexts;

        xTexts = xlayer.selectAll(".mbc-x-label").data(xScale.domain());
        xTexts.enter().append("g").classed("mbc-x-label", true).attr("transform", function (d) {
            var x = xScale(d) + xScale.rangeBand() / 2;
            var y = xAxisOrient === "bottom" ? canvas.height() + 35 : -25;
            return "translate(" + x + ", " + y + ")";
        }).append("text").text(function (d, i) {
            var label = "";
            if (i < subLabels.length) {
                label = subLabels[i] || "";
            }

            return label;
        }).attrs({
            "text-anchor": "start",
            "dx": this.get("subLabelDx")
        });
    },

    getScale: function getScale() {
        return this.get('scale');
    },

    getAxis: function getAxis() {
        return this.get('axis');
    },

    //=================== util methods ============================

    isInvalidDate: function isInvalidDate(date) {
        if (date instanceof Date && date.toString() !== 'Invalid Date') {
            return false;
        }

        return true;
    },

    checkLabelsWidth: function checkLabelsWidth(labelList, axisWidth, spacing, font) {
        var totalSpacing = spacing * (labelList.length - 1);
        var totalWidth = this.getTextWidth({
            font: font,
            text: labelList.join('')
        });

        //axis can show all labels well.
        if (axisWidth > totalWidth + totalSpacing) {
            return true;
        }

        return false;
    },

    getTextWidth: function getTextWidth(option) {

        var canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement('canvas'));
        var context = canvas.getContext('2d');

        context.font = option.font;

        var dimension = context.measureText(option.text);

        return dimension.width;
    },

    calcMaxTextWidth: function calcMaxTextWidth(texts) {
        var _this = this;
        var font = this.get('font');
        var maxTextWidth = d3.max(texts.map(function (text) {
            return _this.getTextWidth({
                font: font,
                text: text
            });
        }));

        return maxTextWidth;
    },

    getDate: function getDate(maskDate) {
        return new Date(Utils.string.unmask(maskDate));
    },

    quarterlyTickFormat: function quarterlyTickFormat(date) {
        var month = +d3.time.format('%m')(date);
        var quarterly = [3, 6, 9, 12];

        if (quarterly.indexOf(month) === -1) {
            return;
        }

        return "Q" + month / 3;
    },

    //========================= getter & setter ============================

    get: function get(key) {
        return this.__attributes[key];
    },

    set: function set(key, value) {
        this.__attributes[key] = value;
    }

});

module.exports = DateAxis;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DateAxis = __webpack_require__(38);

module.exports = {
    DateAxis: DateAxis
};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var array = __webpack_require__(14);
var chart = __webpack_require__(40);
var fn = __webpack_require__(44);
var object = __webpack_require__(3);
var str = __webpack_require__(46);
var svg = __webpack_require__(47);
var colors = __webpack_require__(41);
var number = __webpack_require__(45);
var generators = __webpack_require__(43);

/** @module Core/Utils */

module.exports = {
    assign: object.assign,
    callFn: fn.call,
    clone: object.clone,
    convertDashToEnDash: str.convertDashToEnDash,
    copy: object.copy,
    dashify: str.dashify,
    extract: object.extract,
    getBoolean: object.getBoolean,
    getDomain: chart.getDomain,
    getGreaterSVGTextWidth: svg.getGreaterSVGTextWidth,
    getRoundToUnits: array.getRoundToUnits,
    getStackedValues: array.getStackedValues,
    getSVGTextWidth: svg.getSVGTextWidth,
    getTickValues: chart.getTickValues,
    hasNegative: array.hasNegative,
    indexOf: array.indexOf,
    isUndefined: object.isUndefined,
    minmax: array.minmax,
    NaNtoNull: object.NaNtoNull,
    removeDuplicates: array.removeDuplicates,
    template: str.template,
    UID: str.UID,

    array: array,
    chart: chart,
    fn: fn,
    object: object,
    string: str,
    svg: svg,
    colors: colors,
    number: number,
    generators: generators
};

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var array = __webpack_require__(14);
var object = __webpack_require__(3);

/**
 * Calculate tickvalues for a given dataset.
 *
 * @param {Array} domain Two values array.
 * @param {Number} ticksNumber Number of ticks to show.
 *
 * @return {Array} Containing the ticks to include in the chart's axis.
 */
var getTickValues = function getTickValues(domain, ticksNumber) {
    ticksNumber = ticksNumber || 4;
    var distance = Math.abs(domain[0] - domain[1]);
    var domainStep = distance / ticksNumber;
    var min = domain[0];
    var max = domain[1];
    var tickValues = [];

    while (min < max) {
        tickValues.push(min);
        min += domainStep;
    }

    tickValues.push(min);

    return tickValues;
};

function ensureGreaterThanOne(num) {
    var power = 0;
    while (num < 10) {
        num = num * 10;
        power++;
    }

    return { number: num, power: power };
}

/**
 * Returns a domain with positive numbers starting from 0 based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @param {boolean} integers Show only integer numbers, without decimal.
 * @param {Number} steps Numbers of intended steps into the domain.
 * @returns {Array} Two values array with the domain.
 */
function getPositiveDomain(allValues, roundTo, integers, steps) {
    var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
    if (max === 0) return [0, 1];
    var ensured = ensureGreaterThanOne(max);
    var mod, power;

    max = ensured.number;
    power = ensured.power;
    roundTo *= Math.pow(10, power);

    if (integers) {
        mod = max % steps;
        while (mod !== 0) {
            max += roundTo;
            mod = max % steps;
        }
    }

    max = max / Math.pow(10, power);

    return [0, max];
}

/**
 * Returns a Symmetrical domain based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @returns
 */
function getSymmetricalDomain(allValues, roundTo, integers, steps) {
    var allPositive = array.getAllPositives(allValues);
    var max = Math.ceil(d3.max(allPositive) / roundTo) * roundTo;
    if (max === 0) return [-1, 1];
    var ensured = ensureGreaterThanOne(max);
    var min, mod, power;

    max = ensured.number;
    power = ensured.power;
    min = max * -1;
    roundTo *= Math.pow(10, power);

    if (integers) {
        mod = max * 2 % steps;
        while (mod !== 0) {
            max += roundTo;
            mod = max * 2 % steps;
        }

        min = max * -1;
    }

    min = min / Math.pow(10, power);
    max = max / Math.pow(10, power);

    return [min, max];
}

/**
 * Returns an Asymmetrical domain based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @returns
 */
function getAsymmetricalDomain(allValues, roundTo) {
    var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
    var min = Math.floor(d3.min(allValues) / roundTo) * roundTo;

    return [min, max];
}

/**
 * Calculates the domain for a certain dataset.
 *
 * @param {Object}? options Options available:
 * <li><b>values:</b> Required. Array of values.
 * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
 * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
 * <li><b>symmetrical:</b> Optional.
 * <li><b>steps:</b> Optional. Intended ticks number.
 *
 * @return {Array} Two values array indicating the domain.
 */
var getDomain = function getDomain(options) {
    options = options || {};
    var allValues = options.values;
    var roundTo = options.roundTo || 10;
    var integers = object.getBoolean(options.integers, false);
    var forceNegative = object.getBoolean(options.forceNegative, false);
    var symmetrical = object.getBoolean(options.symmetrical, true);
    var raw = object.getBoolean(options.raw, false);
    var steps = options.steps || 4;
    var negatives;

    if (!allValues || allValues.length === 0) {
        return [0, 1];
    }

    negatives = array.hasNegative(allValues);
    allValues = array.removeDuplicates(allValues);

    if (raw) {
        return [d3.min(allValues), d3.max(allValues)];
    }

    if (!negatives && !forceNegative) {
        return getPositiveDomain(allValues, roundTo, integers, steps);
    } else if (symmetrical) {
        return getSymmetricalDomain(allValues, roundTo, integers, steps);
    } else {
        return getAsymmetricalDomain(allValues, roundTo, integers, steps);
    }
};

/**
 * Returns the index of a given value into a range array.
 * @param {Number} val Value to find index into range array.
 * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
 * @return {Number} The range index or -1.
 */
function getRangeIndex(val, range) {
    for (var i = 0; i < range.length; i++) {
        if (val > range[i][0] && (val <= range[i][1] || range[i][1] === undefined)) {
            return i;
        }
    }

    return -1;
}

/**
 * Returns the value of a given value into a values array.
 * @param {Number} val Value to find index into range array.
 * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
 * @param {Array} values Values to return
 * @return {Object} The value that matches range index or `undefined`.
 */
function getRangeValue(val, range, values) {
    var index = getRangeIndex(val, range);
    if (index !== -1) return values[index];
}

/**
 * Returns the calculated padding between bars
 * @param {Array} num the number of bars
 * @param {Number} dim the height or width of the canvas
 * @param {String} orient whether horizontal or vertical bar chart
 * @return {String} type whether standard or grouped bars
 */
function getBarPadding(num, dim, orient) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "standard";


    var padding = 9;
    var ratio = dim / num;

    if (orient === "horizontal" || orient === "vertical" && type === "standard") {

        if (ratio > 21) {
            return padding;
        } else if (ratio <= 21 && ratio > 14) {
            padding = 6;
        } else if (ratio <= 14 && ratio > 7) {
            padding = 3;
        } else {
            padding = 1;
        }
    } else if (orient === "vertical" && type === "grouped") {

        if (ratio > 16.5) {
            return padding;
        } else if (ratio <= 16.5 && ratio > 11) {
            padding = 6;
        } else if (ratio <= 11 && ratio > 5.5) {
            padding = 3;
        } else {
            padding = 1;
        }
    }

    return padding;
}

module.exports = {
    getTickValues: getTickValues,
    getDomain: getDomain,
    getRangeIndex: getRangeIndex,
    getRangeValue: getRangeValue,
    getBarPadding: getBarPadding
};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mds_constants = __webpack_require__(7).constants;
var mds_chart_color = mds_constants["chart-color"];

/**
 * deprecating `var colors` in v3.0.0
 */
var colors = {
    "blue": mds_chart_color["1"],
    "maroon": mds_chart_color["2"],
    "teal": mds_chart_color["8"],
    "orange": mds_chart_color["7"],
    "green": mds_chart_color["9"],
    "violet": mds_chart_color["6"],
    "yellow": mds_chart_color["3"],
    "cyan": mds_chart_color["5"],
    "dark-green": mds_chart_color["4"],
    "red": mds_constants["color"]["red"]["50"],
    "light-red": mds_chart_color["10"],
    "dark-violet": mds_chart_color["11"],
    "dark-yellow": mds_chart_color["12"],
    "aqua": mds_chart_color["13"],
    "bright-orange": mds_chart_color["14"],
    "light-green": mds_chart_color["15"],
    "white": mds_constants["color"].white,
    "grey1": mds_constants["color"]["neutral"]["90"],
    "grey2": mds_constants["background-color"].light,
    "grey3": mds_constants["color"]["neutral"]["80"],
    "grey4": mds_constants["color"]["neutral"]["80"],
    "grey5": mds_constants["color"]["neutral"]["50"],
    "grey6": mds_constants["color"]["neutral"]["37"],
    "grey7": mds_constants["color"]["neutral"]["12"],
    "black": mds_constants["color"].black
};

var primary = [mds_chart_color["1"], mds_chart_color["2"], mds_chart_color["3"], mds_chart_color["4"], mds_chart_color["5"], mds_chart_color["6"], mds_chart_color["7"], mds_chart_color["8"], mds_chart_color["9"]];

var secondary = [mds_chart_color["10"], mds_chart_color["11"], mds_chart_color["12"], mds_chart_color["13"], mds_chart_color["14"], mds_chart_color["15"]];

var palettes = [primary, secondary];

var combined = palettes.reduce(function (a, b) {
    return a.concat(b);
}, []);

module.exports = {
    colors: colors,
    primary: primary,
    secondary: secondary,
    combined: combined,
    mds_constants: mds_constants,
    mds_chart_color: mds_chart_color
};

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var names = ["Asia/Pacific Long-Short Equity", "Bear-Market Equity", "China Long-Short Equity", "Convertible Arbitrage", "Currency", "Debt Arbitage", "Distressed Securities", "Diversified Arbitage", "Emrg-Mkta Long-Short Equity", "Equity Market Neutral", "Europe Long-Short Equity", "Event Driven", "Global Long-Short Equity", "Global Macro", "Long-Short Debt", "Merger Arbitage", "Multistrategy", "Systematic Futures", "U.S. Long-Short Equity", "U.S. Sm-Cap Lg-Short Equity", "Volatility"];

function getDummyArray(n) {
    var i = 0;
    var arr = [];
    var sign;
    for (; i < n; i++) {
        sign = Math.random() < 0.5 ? -1 : 1;
        arr.push(Math.random() * sign);
    }

    return arr;
}

function getRandomName() {
    return names[Math.floor(names.length * Math.random())];
}

function getDummyRows(num) {
    var length = num || 3 + Math.floor(Math.random() * 47);
    var i = 0;
    var rows = [];
    var name;

    for (; i < length; i++) {
        name = getRandomName();
        rows.push(name);
    }

    return rows;
}

function getDummyMatrix(num) {
    var i;
    var j;
    var matrix = [];
    var length = num || 3 + Math.floor(Math.random() * 47);
    var sign, value;

    // for (i = 0; i < num; i++) {
    //     matrix[i] = [];
    // }

    for (i = 0; i < length; i++) {
        for (j = 0; j < length; j++) {
            if (!matrix[i]) matrix[i] = [];
            if (!matrix[j]) matrix[j] = [];

            sign = Math.random() < 0.5 ? -1 : 1;
            value = Math.random() * sign;
            if (j < i) {
                matrix[i][j] = value;
                matrix[j][i] = value;
            } else if (i === j) {
                matrix[i][j] = 1;
                break;
            }
        }
    }

    return matrix;
}

function grow(matrix) {
    var arr = getDummyArray(matrix.length);
    arr.forEach(function (val, i) {
        matrix[i].push(val);
    });

    arr.push(1);
    matrix.push(arr);
    return matrix;
}

function dataset(num) {
    var length = num || 3 + Math.floor(Math.random() * 47);
    var dummyRows = getDummyRows(length);
    var dummyMatrix = getDummyMatrix(length);

    return {
        rows: dummyRows,
        matrix: dummyMatrix
    };
}

module.exports = {
    matrix: getDummyMatrix,
    rows: getDummyRows,
    array: getDummyArray,
    dataset: dataset,
    grow: grow,
    name: getRandomName
};

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crmatrix = __webpack_require__(42);
/**
 * @fileOverview Generates "Lorem ipsum" style text.
 * @author rviscomi@gmail.com Rick Viscomi,
 * 		tinsley@tinsology.net Mathew Tinsley
 * @version 1.0
 */

/**
 *	Copyright (c) 2009, Mathew Tinsley (tinsley@tinsology.net)
 *	All rights reserved.
 *
 *	Redistribution and use in source and binary forms, with or without
 *	modification, are permitted provided that the following conditions are met:
 *		* Redistributions of source code must retain the above copyright
 *		  notice, this list of conditions and the following disclaimer.
 *		* Redistributions in binary form must reproduce the above copyright
 *		  notice, this list of conditions and the following disclaimer in the
 *		  documentation and/or other materials provided with the distribution.
 *		* Neither the name of the organization nor the
 *		  names of its contributors may be used to endorse or promote products
 *		  derived from this software without specific prior written permission.
 *
 *	THIS SOFTWARE IS PROVIDED BY MATHEW TINSLEY ""AS IS"" AND ANY
 *	EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *	WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 *	DISCLAIMED. IN NO EVENT SHALL <copyright holder> BE LIABLE FOR ANY
 *	DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 *	(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 *	LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 *	ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 *	(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 *	SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class Jibborish generator.
 */
var LoremIpsum = function LoremIpsum() {};

/**
 * Average number of words per sentence.
 * @constant {number}
 */
LoremIpsum.WORDS_PER_SENTENCE_AVG = 24.460;

/**
 * Standard deviation of the number of words per sentence.
 * @constant {number}
 */
LoremIpsum.WORDS_PER_SENTENCE_STD = 5.080;

/**
 * List of possible words.
 * @constant {Array.string}
 */
LoremIpsum.WORDS = ["lorem", "ipsum", "dolor", "sit", "amet", "consectetur", "adipiscing", "elit", "curabitur", "vel", "hendrerit", "libero", "eleifend", "blandit", "nunc", "ornare", "odio", "ut", "orci", "gravida", "imperdiet", "nullam", "purus", "lacinia", "a", "pretium", "quis", "congue", "praesent", "sagittis", "laoreet", "auctor", "mauris", "non", "velit", "eros", "dictum", "proin", "accumsan", "sapien", "nec", "massa", "volutpat", "venenatis", "sed", "eu", "molestie", "lacus", "quisque", "porttitor", "ligula", "dui", "mollis", "tempus", "at", "magna", "vestibulum", "turpis", "ac", "diam", "tincidunt", "id", "condimentum", "enim", "sodales", "in", "hac", "habitasse", "platea", "dictumst", "aenean", "neque", "fusce", "augue", "leo", "eget", "semper", "mattis", "tortor", "scelerisque", "nulla", "interdum", "tellus", "malesuada", "rhoncus", "porta", "sem", "aliquet", "et", "nam", "suspendisse", "potenti", "vivamus", "luctus", "fringilla", "erat", "donec", "justo", "vehicula", "ultricies", "varius", "ante", "primis", "faucibus", "ultrices", "posuere", "cubilia", "curae", "etiam", "cursus", "aliquam", "quam", "dapibus", "nisl", "feugiat", "egestas", "class", "aptent", "taciti", "sociosqu", "ad", "litora", "torquent", "per", "conubia", "nostra", "inceptos", "himenaeos", "phasellus", "nibh", "pulvinar", "vitae", "urna", "iaculis", "lobortis", "nisi", "viverra", "arcu", "morbi", "pellentesque", "metus", "commodo", "ut", "facilisis", "felis", "tristique", "ullamcorper", "placerat", "aenean", "convallis", "sollicitudin", "integer", "rutrum", "duis", "est", "etiam", "bibendum", "donec", "pharetra", "vulputate", "maecenas", "mi", "fermentum", "consequat", "suscipit", "aliquam", "habitant", "senectus", "netus", "fames", "quisque", "euismod", "curabitur", "lectus", "elementum", "tempor", "risus", "cras"];

/**
 * Generate "Lorem ipsum" style words.
 * @param numWords {number} Number of words to generate.
 * @return {string} "Lorem ipsum..."
 */
LoremIpsum.prototype.generate = function (numWords, punctuate) {
    var words, ii, position, word, current, sentences, sentenceLength, sentence;

    /**
    * @default 100
    */
    numWords = numWords || 100;

    words = [LoremIpsum.WORDS[0], LoremIpsum.WORDS[1]];
    numWords -= 2;

    for (ii = 0; ii < numWords; ii++) {
        position = Math.floor(Math.random() * LoremIpsum.WORDS.length);
        word = LoremIpsum.WORDS[position];

        if (ii > 0 && words[ii - 1] === word) {
            ii -= 1;
        } else {
            words[ii] = word;
        }
    }

    sentences = [];
    current = 0;

    while (numWords > 0) {
        sentenceLength = this.getRandomSentenceLength();

        if (numWords - sentenceLength < 4) {
            sentenceLength = numWords;
        }

        numWords -= sentenceLength;

        sentence = [];

        for (ii = current; ii < current + sentenceLength; ii++) {
            sentence.push(words[ii]);
        }

        if (punctuate) {
            sentence = this.punctuate(sentence);
        }

        current += sentenceLength;
        sentences.push(sentence.join(" "));
    }

    return sentences.join(" ");
};

/**
 * Insert commas and periods in the given sentence.
 * @param {Array.string} sentence List of words in the sentence.
 * @return {Array.string} Sentence with punctuation added.
 */
LoremIpsum.prototype.punctuate = function (sentence) {
    var wordLength, numCommas, ii, position;

    wordLength = sentence.length;

    /* End the sentence with a period. */
    sentence[wordLength - 1] += ".";

    if (wordLength < 4) {
        return sentence;
    }

    numCommas = this.getRandomCommaCount(wordLength);

    for (ii = 0; ii <= numCommas; ii++) {
        position = Math.round(ii * wordLength / (numCommas + 1));

        if (position < wordLength - 1 && position > 0) {
            /* Add the comma. */
            sentence[position] += ",";
        }
    }

    /* Capitalize the first word in the sentence. */
    sentence[0] = sentence[0].charAt(0).toUpperCase() + sentence[0].slice(1);

    return sentence;
};

/**
 * Produces a random number of commas.
 * @param {number} wordLength Number of words in the sentence.
 * @return {number} Random number of commas
 */
LoremIpsum.prototype.getRandomCommaCount = function (wordLength) {
    var base, average, standardDeviation;

    /* Arbitrary. */
    base = 6;

    average = Math.log(wordLength) / Math.log(base);
    standardDeviation = average / base;

    return Math.round(this.gaussMS(average, standardDeviation));
};

/**
 * Produces a random sentence length based on the average word length
 * of an English sentence.
 * @return {number} Random sentence length
 */
LoremIpsum.prototype.getRandomSentenceLength = function () {
    return Math.round(this.gaussMS(LoremIpsum.WORDS_PER_SENTENCE_AVG, LoremIpsum.WORDS_PER_SENTENCE_STD));
};

/**
 * Produces a random number.
 * @return {number} Random number
 */
LoremIpsum.prototype.gauss = function () {
    return Math.random() * 2 - 1 + (Math.random() * 2 - 1) + (Math.random() * 2 - 1);
};

/**
 * Produces a random number with Gaussian distribution.
 * @param {number} mean
 * @param {number} standardDeviation
 * @return {number} Random number
 */
LoremIpsum.prototype.gaussMS = function (mean, standardDeviation) {
    return Math.round(this.gauss() * standardDeviation + mean);
};

function Tickers() {}

Tickers.TICKERS = ["PIH", "FLWS", "FCCY", "SRCE", "VNET", "TWOU", "JOBS", "CAFD", "EGHT", "AVHI", "SHLM", "AAON", "ABAX", "ABEO", "ABEOW", "ABIL", "ABMD", "AXAS", "ACIU", "ACIA", "ACTG", "ACHC", "ACAD", "ACST", "AXDX", "XLRN", "ANCX", "ARAY", "ACRX", "ACET", "AKAO", "ACHN", "ACIW", "ACRS", "ACNB", "ACOR", "ACTS", "ACPW", "ATVI", "ACTA", "ACUR", "ACXM", "ADMS", "ADMP", "ADAP", "ADUS", "AEY", "IOTS", "ADMA", "ADBE", "ADTN", "ADRO", "AAAP", "ADES", "AEIS", "AMD", "ADXS", "ADXSW", "ADVM", "MAUI", "AEGR", "AEGN", "AGLE", "AEHR", "AMTX", "AEPI", "AERI", "AVAV", "AEZS", "AEMD", "AFMD", "AGEN", "AGRX", "AGYS", "AGIO", "AGNC", "AGNCB", "AGNCP", "AGFS", "AGFSW", "AIMT", "AIRM", "AIRT", "ATSG", "AIRG", "AMCN", "AIXG", "AKAM", "AKTX", "AKBA", "AKER", "AKRX", "ALRM", "ALSK", "AMRI", "ALBO", "ABDC", "ADHD", "ALDR", "ALDX", "ALXN", "ALCO", "ALGN", "ALIM", "ALJJ", "ALKS", "ABTX", "ALGT", "AIQ", "AHGP", "AMMA", "ARLP", "AHPI", "AMOT", "ALQA", "ALLT", "MDRX", "AFAM", "ALNY", "AOSL", "GOOG", "GOOGL", "SMCP", "ATEC", "ASPS", "AIMC", "AMAG", "AMRN", "AMRK", "AYA", "AMZN", "AMBC", "AMBCW", "AMBA", "AMCX", "DOX", "AMDA", "AMED", "UHAL", "ATAX", "AMOV", "AAL", "ACSF", "ACAS", "AETI", "AMNB", "ANAT", "APEI", "ARII", "AMRB", "AMSWA", "AMSC", "AMWD", "CRMT", "ABCB", "AMSF", "ASRV", "ASRVP", "ATLO", "AMGN", "FOLD", "AMKR", "AMPH", "IBUY", "AMSG", "AMSGP", "ASYS", "AFSI", "AMRS", "ADI", "ALOG", "AVXL", "ANCB", "ANDA", "ANDAR", "ANDAU", "ANDAW", "ANGI", "ANGO", "ANIP", "ANIK", "ANSS", "ATRS", "ANTH", "ABAC", "APOG", "APOL", "AINV", "APPF", "AAPL", "ARCI", "APDN", "APDNW", "AGTC", "AMAT", "AMCC", "AAOI", "AREX", "APTI", "APRI", "APVO", "APTO", "AQMS", "AQXP", "ARDM", "ARLZ", "PETX", "ABUS", "ARCW", "ABIO", "RKDA", "ARCB", "ACGL", "ACGLP", "APLP", "ACAT", "ARDX", "ARNA", "ARCC", "AGII", "AGIIL", "ARGS", "ARIS", "ARIA", "ARKR", "ARTX", "ARWA", "ARWAR", "ARWAU", "ARWAW", "ARQL", "ARRY", "ARRS", "DWAT", "AROW", "ARWR", "ARTNA", "ARTW", "ASBB", "ASNA", "ASND", "ASCMA", "APWC", "ASML", "AZPN", "ASMB", "ASFI", "ASTE", "ATRO", "ALOT", "ASTC", "ASUR", "ATAI", "ATRA", "ATHN", "ATHX", "AAPC", "AAME", "ACBI", "ACFC", "ABY", "ATLC", "AAWW", "AFH", "TEAM", "ATNI", "ATOM", "ATOS", "ATRC", "ATRI", "ATTU", "LIFE", "AUBN", "BOLD", "AUDC", "AUPH", "EARS", "ABTL", "ADSK", "ADP", "AVEO", "AVXS", "AVNW", "AVID", "AVGR", "AVIR", "CAR", "AHPAU", "AWRE", "AXAR", "AXARU", "AXARW", "ACLS", "AXGN", "AXSM", "AXTI", "AZRX", "BCOM", "RILY", "RILYL", "BOSC", "BEAV", "BIDU", "BCPC", "BWINA", "BWINB", "BLDP", "BANF", "BANFP", "BCTF", "BKMU", "BOCH", "BMRC", "BKSC", "BOTJ", "OZRK", "BFIN", "BWFG", "BANR", "BZUN", "TAPR", "DLBL", "BHAC", "BHACR", "BHACU", "BHACW", "BBSI", "BSET", "BYBK", "BV", "BCBP", "BECN", "BSF", "BBGI", "BEBE", "BBBY", "BGNE", "BELFA", "BELFB", "BLPH", "BLCM", "BNCL", "BNFT", "BNTC", "BNTCW", "BGCP", "BGFV", "BASI", "ORPN", "BIOC", "BCRX", "BDSI", "BIIB", "BIOL", "BLFS", "BLRX", "BMRN", "BMRA", "BVXV", "BVXVW", "BPTH", "BIOS", "BBC", "BBP", "BSTC", "BSTG", "BSPM", "TECH", "BEAT", "BJRI", "BBOX", "BDE", "BLKB", "BBRY", "HAWK", "BL", "BKCC", "ADRA", "ADRD", "ADRE", "ADRU", "BLMN", "BCOR", "BLBD", "BUFF", "BHBK", "NILE", "BLUE", "BKEP", "BKEPP", "BPMC", "ITEQ", "BMCH", "BNCN", "BOBE", "BOFI", "BOFIL", "WIFI", "BOJA", "BOKF", "BOKFL", "BNSO", "BPFH", "BPFHP", "BPFHW", "EPAY", "BLVD", "BLVDU", "BLVDW", "BCLI", "BBRG", "BDGE", "BLIN          ", "BRID", "BCOV", "AVGO", "BSFT", "BVSN", "BYFC", "BWEN", "BRCD", "BRKL", "BRKS", "BRKR", "BMTC", "BLMT", "BSQR", "BWLD", "BLDR", "BMLA", "BUR", "CFFI", "CHRW", "CA", "CCMP", "CDNS", "CDZI", "CACQ", "CZR", "CSTE", "PRSS", "CLBS", "CLMS", "CHY", "CHI", "CCD", "CHW", "CGO", "CSQ", "CAMP", "CVGW", "CFNB", "CALA", "CALD", "CALM", "CLMT", "ABCD", "CAC", "CAMT", "CSIQ", "CGIX", "CPHC", "CPLA", "CBF", "CCBG", "CPLP", "CSWC", "CPTA", "CLAC", "CLACU", "CLACW", "CFFN", "CAPN", "CAPNW", "CAPR", "CSTR", "CPST", "CARA", "CARB", "CCN", "CCNWW", "CFNL", "CRME", "CSII", "CATM", "CDNA", "CECO", "CTRE", "CKEC", "CLBH", "CARO", "CART", "CRZO", "TAST", "CRTN", "CARV", "CASM", "CACB", "CASC", "CWST", "CASY", "CASI", "CASS", "CATB", "CBIO", "CPRX", "CATY", "CATYW", "CVCO", "CAVM", "CBFV", "CBOE", "CDK", "CDW", "CECE", "CELG", "CELGZ", "CLDX", "APOP", "APOPW", "CLRB", "CLRBW", "CLRBZ", "CLLS", "CBMG", "CLSN", "CYAD", "CEMP", "CETX", "CDEV", "CDEVW", "CSFL", "CETV", "CFBK", "CENT", "CENTA", "CVCY", "CFCB", "CENX", "CNBKA", "CNTY", "CRNT", "CERC", "CERCW", "CERCZ", "CERN", "CERU", "CERS", "KOOL", "CEVA", "CFCO", "CFCOU", "CFCOW", "CSBR", "CYOU", "HOTR", "HOTRW", "CTHR", "GTLS", "CHTR", "CHFN", "CHKP", "CHEK", "CHEKW", "CEMI", "CHFC", "CCXI", "CHMG", "CHKE", "CHMA", "PLCE", "CMRX", "CADC", "CALI", "CAAS", "CBAK", "CBPO", "CCCL", "CCCR", "CCRC", "JRJC", "HGSH", "CNIT", "CJJD", "CLDC", "CLDCW", "HTHT", "CHNR", "CREG", "CNTF", "CXDC", "CCIH", "CNET", "IMOS", "CDXC", "CHSCL", "CHSCM", "CHSCN", "CHSCO", "CHSCP", "CHDN", "CHUY", "CDTX", "CMCT", "CMPR", "CINF", "CIDM", "CTAS", "CPHR", "CRUS", "CSCO", "CTRN", "CZNC", "CZWI", "CZFC", "CIZN", "CTXS", "CHCO", "CIVB", "CIVBP", "CDTI", "CLNE", "CLNT", "CLFD", "CLRO", "CLSD", "CLIR", "CBLI", "CSBK", "CLVS", "CMFN", "CME", "CCNE", "CISG", "CNV", "CWAY", "COBZ", "COKE", "CDXS", "CVLY", "JVA", "CCOI", "CGNT", "COGT", "CGNX", "CTSH", "COHR", "CHRS", "COHU", "CLCT", "COLL", "CIGI", "CBAN", "CLCD", "COLB", "COLM", "CMCO", "CBMX", "CBMXW", "CMCSA", "CBSH", "CBSHP", "CUBN", "CHUBA", "CHUBK", "CVGI", "COMM", "CSAL", "JCS", "ESXB", "CYHHZ", "CTBI", "CWBC", "CVLT", "CGEN", "CPSI", "CTG", "SCOR", "CHCI", "CMTL", "CNAT", "CNCE", "CXRX", "CCUR", "CDOR", "CFMS", "CNFR", "CNMD", "CTWS", "CNOB", "CNXR", "CONN", "CNSL", "CWCO", "CPSS", "CFRX", "CFRXW", "CTRV", "CTRL", "CPAA", "CPAAU", "CPAAW", "CPRT", "COYN", "COYNW", "CRBP", "CORT", "CORE", "CORI", "CSOD", "CRVL", "CRVS", "CSGP", "COST", "CPAH", "ICBK", "COUP", "CVTI", "COVS", "COWN", "COWNL", "PMTS", "CPSH", "CRAI", "CBRL", "BREW", "CRAY", "CACC", "GLDI", "SLVO", "CREE", "CRESY", "CRSP", "CRTO", "CROX", "CCRN", "XRDC", "CRDS", "CRWS", "CYRX", "CYRXW", "CSGS", "CCLP", "CSPI", "CSWI", "CSX", "CTIC", "CTIB", "CTRP", "CUNB", "CUI", "CPIX", "CMLS", "CRIS", "CUTR", "CVBF", "CVV", "CYAN", "CYBR", "CYBE", "CYCC", "CYCCP", "CBAY", "CYNO", "CY", "CYRN", "CONE", "CYTK", "CTMX", "CYTX", "CYTXW", "CTSO", "CYTR", "DJCO", "DAKT", "DRIO", "DRIOW", "DZSI", "DAIO", "DTLK", "DRAM", "DWCH", "PLAY", "DTEA", "DWSN", "DBVT", "DFRG", "TACO", "TACOW", "DCTH", "DMPI", "DGAS", "DELT", "DELTW", "DENN", "XRAY", "DEPO", "DSCI", "DERM", "DEST", "DXLG", "DSWL", "DTRM", "DXCM", "DXTR", "DHXM", "DHIL", "FANG", "DCIX", "DRNA", "DFBG", "DFFN", "DGII", "DMRC", "DRAD", "DGLY", "APPS", "DCOM", "DMTX", "DIOD", "DPRX", "DISCA", "DISCB", "DISCK", "DISH", "DVCR", "SAUC", "DLHC", "BOOM", "DNBF", "DLTR", "DGICA", "DGICB", "DMLP", "DORM", "EAGL", "EAGLU", "EAGLW", "DRWI", "DRYS", "DSKX", "DSPG", "DTSI", "DLTH", "DNKN", "DRRX", "DXPE", "DYSL", "DYNT", "DVAX", "ETFC", "EBMT", "EGBN", "EGLE", "EGRX", "IGLEU", "ELNK", "EWBC", "EACQ", "EACQU", "EACQW", "EML", "EVBS", "EVGBC", "EVSTC", "EVLMC", "EBAY", "EBAYL", "EBIX", "ELON", "ECHO", "SATS", "EEI", "ECAC", "ECACR", "ECACU", "ESES", "EDAP", "EDGE", "EDGW", "EDIT", "EDUC", "EFUT", "EGAN", "EGLT", "EHTH", "EIGR", "EKSO", "LOCO", "EMITF", "ESLT", "ERI", "ESIO", "EA", "EFII", "ELSE", "ELEC", "ELECU", "ELECW", "EBIO", "DWAC", "CAPX", "ESBK", "ELTK", "EMCI", "EMCF", "EMKR", "EMMS", "NYNY", "ERS", "ENTA", "ECPG", "WIRE", "ENDP", "ECYT", "ELGX", "EIGI", "WATT", "EFOI", "ERII", "ENOC", "ENG", "ENPH", "ESGR", "ENFC", "ENTG", "ENTL", "ETRM", "EBTC", "EFSC", "EGT", "ENZY          ", "EPZM", "PLUS", "EQIX", "EQFN", "EQBK", "ERIC", "ERIE", "ESCA", "ESPR", "ESSA", "EPIX", "ESND", "UTES", "ETSY", "CLWT", "EEFT", "ESEA", "EVEP", "EVBG", "EVK", "MRAM", "EVLV", "EVOK", "EVOL", "EXA", "EXAS", "EXAC", "EXEL", "EXFO", "EXLS", "EXPE", "EXPD", "EXPO", "ESRX", "XOG", "EXTR", "EYEG", "EYEGW", "EZPW", "FFIV", "FB", "FRP", "FALC", "DAVE", "FARM", "FFKT", "FMNB", "FARO", "FAST", "FATE", "FBSS", "FBRC", "FDML", "FNHC", "FHCO", "FENX", "GSM", "FCSC", "FGEN", "ONEQ", "LION", "FDUS", "FRGI", "FSAM", "FSC", "FSCFL", "FSFR", "FITB", "FITBI", "FNGN", "FISI", "FNSR", "FNJN", "FEYE", "FBNC", "FNLC", "FRBA", "BUSE", "FBIZ", "FCAP", "FCFS", "FCNCA", "FCBC", "FCCO", "FCFP", "FBNK", "FDEF", "FFBC", "FFBCW", "FFIN", "THFF", "FFNW", "FFWM", "FGBI", "FHB", "INBK", "INBKL", "FIBK", "FRME", "FMBH", "FMBI", "FNBC", "FNWB", "FSFG", "FSLR", "FSBK", "FAAR", "FPA", "BICK", "FBZ", "FCAN", "FTCS", "FCEF", "FCA", "FDT", "FDTS", "FVC", "FV", "IFV", "FEM", "FEMB", "FEMS", "FTSM", "FEP", "FEUZ", "FGM", "FTGC", "FTHI", "HYLS", "FHK", "FTAG", "FTRI", "FPXI", "YDIV", "SKYY", "FJP", "FEX", "FTC", "FTA", "FLN", "FTLB", "LMBS", "FMB", "FMK", "FNX", "FNY", "FNK", "FAD", "FAB", "MDIV", "MCEF", "QABA", "FTXO", "QCLN", "GRID", "CIBR", "FTXG", "CARZ", "FTXN", "FTXH", "FTXD", "RDVY", "FTXL", "FONE", "TDIV", "FTXR", "QQEW", "QQXT", "QTEC", "AIRR", "QINC", "RFAP", "RFDI", "RFEM", "RFEU", "FTSL", "FYX", "FYC", "FYT", "FKO", "FCVT", "FDIV", "FSZ", "FTW", "TUSA", "FKU", "FUNC", "FUSB", "SVVC", "FSV", "FISV", "FIVE", "FPRX", "FVE", "FIVN", "FLML", "FLEX", "FLKS", "FLXN", "SKOR", "LKOR", "MBSD", "ASET", "ESGG", "ESG", "QLC", "FPAY", "FLXS", "FLIR", "FLDM", "FFIC", "FOMX", "FOGO", "FONR", "FH", "FORM", "FORTY", "FORR", "FRTA", "FTNT", "FBIO", "FWRD", "FORD", "FWP", "FOSL", "FMI", "FOXF", "FRAN", "FELE", "FRED", "RAIL", "FEIM", "FRPT", "FTEO", "FTR", "FTRPR", "FRPH", "FSBW", "FSBC", "FTD", "FTEK", "FCEL", "FLGT", "FORK", "FLL", "FULT", "FNCX", "FSNN", "FFHL", "FXCM", "GK", "WILC", "GAIA", "GLPG", "GALT", "GALTU", "GALTW", "GALE", "GLMD", "GLPI", "GPIC", "GRMN", "GARS", "GDS", "GEMP", "GENC", "GNCMA", "GFN", "GFNCP", "GFNSL", "GENE", "GNUS", "GNMK", "GNCA", "GHDX", "GNTX", "THRM", "GNVC", "GTWN", "GEOS", "GABC", "GERN", "GEVO", "ROCK", "GIGM", "GIGA", "GIII", "GILT", "GILD", "GBCI", "GLAD", "GLADO", "GOOD", "GOODM", "GOODO", "GOODP", "GAIN", "GAINM", "GAINN", "GAINO", "LAND", "LANDP", "GLBZ", "GBT", "ENT", "GBLI", "GBLIZ", "GPAC", "GPACU", "GPACW", "SELF", "GSOL", "GWRS", "KRMA", "FINX", "ACTX", "BFIT", "SNSR", "LNGR", "MILN", "EFAS", "QQQC", "BOTZ", "CATH", "SOCL", "ALTY", "SRET", "YLCO", "GLBS", "GLUU", "GLYC", "GOGO", "GLNG", "GMLP", "GDEN", "GOGL", "GBDC", "GTIM", "GPRO", "GMAN", "GOV", "GOVNI", "GPIA", "GPIAU", "GPIAW", "LOPE", "GRVY", "FULLL", "GECC", "GEC", "GLDD", "GSBC", "GNBC", "GRBK", "GPP", "GPRE", "GCBC", "GLRE", "GSUM", "GRIF", "GRFS", "GRPN", "OMAB", "GGAL", "GSIT", "GSVC", "GTXI", "GTYH", "GTYHU", "GTYHW", "GBNK", "GFED", "GUID", "GIFI", "GURE", "GPOR", "GWPH", "GWGH", "GYRO", "HEES", "HLG", "HNRG", "HALL", "HALO", "HBK", "HBHC", "HBHCL", "HNH", "HAFC", "HQCL", "HONE", "HDNG", "HLIT", "HRMN", "HRMNU", "HRMNW", "TINY", "HBIO", "HCAP", "HCAPL", "HAS", "HA", "HCOM", "HWKN", "HWBK", "HAYN", "HDS", "HIIQ", "HCSG", "HQY", "HSTM", "HWAY", "HTLD", "HTLF", "HTBX", "HSII", "HELE", "HMNY", "HMTV", "HNNA", "HCAC", "HCACU", "HCACW", "HSIC", "HTBK", "HFWA", "HEOP", "HCCI", "MLHR", "HRTX", "HSKA", "HIBB", "SNLN", "HPJ", "HIHO", "HIMX", "HIFS", "HSGX", "HMNF", "HMSY", "HOLI", "HOLX", "HBCP", "HOMB", "HFBL", "HMST", "HMTA", "HTBI", "HMU", "CETC", "HOFT", "HOPE", "HFBC", "HBNC", "HZNP", "HRZN", "HDP", "HPT", "HPTRP", "TWNK", "TWNKW", "HMHC", "HWCC", "HOVNP", "HBMD", "HSNI", "HTGM", "HUBG", "HSON", "HDSN", "HUNTU", "HBAN", "HBANN", "HBANO", "HBANP", "HURC", "HURN", "HCM", "HBP", "HDRA", "HDRAR", "HDRAU", "HDRAW", "HYGS", "IDSY", "IAC", "IKGH", "IBKC", "IBKCO", "IBKCP", "ICAD", "IEP", "ICFI", "ICLR", "ICON", "ICUI", "IPWR", "INVE", "IDRA", "IDXX", "IESC", "IROQ", "IRG", "RXDX", "INFO", "IIVI", "KANG", "IKNX", "ILG", "ILMN", "ISNS", "IMMR", "ICCC", "IMDZ", "IMNP          ", "IMGN", "IMMU", "IPXL", "PI", "IMMY", "INCR", "INCY", "INDB", "IBCP", "IBTX", "IDSA", "INFN", "INFI", "IPCC", "III", "IFON", "IMKTA", "INWK", "INNL", "INOD", "IPHS", "IOSP", "ISSC", "INVA", "INGN", "ITEK", "INOV", "INO", "INSG", "NSIT", "ISIG", "INSM", "IIIN", "PODD", "INSY", "NTEC", "IART", "IDTI", "INTC", "IQNT", "NTLA", "IPCI", "IPAR", "IBKR", "ININ", "ICPT", "IDCC", "TILE", "LINK", "IMI", "INAP", "IBOC", "ISCA", "IGLD", "IIJI", "IDXG", "XENT", "INTX", "ISIL", "IVAC", "INTL", "ITCI", "IIN", "INTU", "ISRG", "INVT", "SNAK", "ISTR", "ISBC", "ITIC", "NVIV", "IVTY", "IONS", "IPAS", "DTYS", "DTYL", "DTUS", "DTUL", "DFVS", "DFVL", "FLAT", "DLBS", "STPP", "IPGP", "IRMD", "IRTC", "IRIX", "IRDM", "IRDMB", "IRBT", "IRWD", "IRCP", "PMPT", "SLQD", "TLT", "AIA", "COMT", "IXUS", "FALN", "IFEU", "IFGL", "IGF", "GNMA", "HYXE", "JKI", "ACWX", "ACWI", "AAXJ", "EWZS", "MCHI", "ESGD", "SCZ", "ESGE", "EEMA", "EUFN", "IEUS", "MPCT", "ENZL", "QAT", "UAE", "IBB", "SOXX", "EMIF", "ICLN", "WOOD", "INDY", "ISHG", "IGOV", "ISLE", "ISRL", "ITI", "ITRI", "ITRN", "ITUS", "IVENC", "IVFGC", "IVFVC", "XXIA", "IXYS", "IZEA", "JJSF", "MAYS", "JBHT", "JCOM", "JASO", "JKHY", "JACK", "JXSB", "JAGX", "JAKK", "JMBA", "JRVR", "JSML", "JSMD", "JASN", "JASNW", "JAZZ", "JD", "JSYN", "JSYNR", "JSYNU", "JSYNW", "JBLU", "JTPY", "JCTCF", "JIVE", "WYIG", "WYIGU", "WYIGW", "JBSS", "JOUT", "JNP", "JUNO", "KTWO", "KALU", "KALV", "KMDA", "KNDI", "KPTI", "KBSF", "KCAP", "KRNY", "KELYA", "KELYB", "KMPH", "KFFB", "KERX", "KEQU", "KTEC", "KTCC", "KFRC", "KE", "KBAL", "KIN", "KGJI", "KINS", "KONE", "KNSL", "KIRK", "KITE", "KTOV", "KTOVW", "KLAC", "KLRE", "KLREU", "KLREW", "KLXI", "KONA", "KZ", "KOPN", "KRNT", "KOSS", "KWEB", "KTOS", "KLIC", "KURA", "KVHI", "FSTR", "LJPC", "LSBK", "LSBG", "LBAI", "LKFN", "LAKE", "LRCX", "LAMR", "LANC", "LCA", "LCAHU", "LCAHW", "LNDC", "LARK", "LMRK", "LMRKO", "LMRKP", "LE", "LSTR", "LNTH", "LTRX", "LSCC", "LAWS", "LAYN", "LCNB", "LBIX", "LGCY", "LGCYO", "LGCYP", "LTXB", "DDBI", "EDBI", "LVHD", "UDBI", "LMAT", "TREE", "LXRX", "LGIH", "LHCG", "LLIT", "LBRDA", "LBRDK", "LEXEA", "LEXEB", "LBTYA", "LBTYB", "LBTYK", "LILA", "LILAK", "LVNTA", "LVNTB", "QVCA", "QVCB", "BATRA", "BATRK", "LMCA", "LMCK", "LSXMA", "LSXMB", "LSXMK", "TAX", "LTRPA", "LTRPB", "LPNT", "LCUT", "LFVN", "LWAY", "LGND", "LTBR", "LPTH", "LMB", "LLNW", "LMNR", "LINC", "LECO", "LIND", "LINDW", "LLTC", "LBIO", "LIOX", "LPCN", "LQDT", "LFUS", "LIVN", "LOB", "LIVE", "LPSN", "LKQ", "LMFA", "LMFAW", "LMIA", "LOGI", "LOGM", "EVAR", "CNCR", "LONE", "LTEA", "LORL", "LOXO", "LPTN", "LPLA", "LRAD", "LYTS", "LULU", "LITE", "LMNX", "LMOS", "LUNA", "MBTF", "MACQ", "MACQU", "MACQW", "MIII", "MIIIU", "MIIIW", "MBVX", "MCBC", "MFNC", "MTSI", "MCUR", "MGNX", "MDGL", "MAGS", "MGLN", "MPET", "MGIC", "CALL", "MNGA", "MGYR", "MHLD", "MSFG", "COOL", "MMYT", "MBUU", "MLVF", "MAMS", "TUSK", "MANH", "LOAN", "MNTX", "MTEX", "MNKD", "MANT", "MARA", "MCHX", "MARPS", "MRNS", "MKTX", "MRLN", "MAR", "MBII", "MRTN", "MMLP", "MRVL", "MASI", "MTCH", "MATN", "MTLS", "MTRX", "MAT", "MATR", "MATW", "MXIM", "MXPT", "MXWL", "MZOR", "MBFI", "MBFIP", "MCFT", "MGRC", "MDCA", "MFIN", "MFINL", "MDGN", "MTBC", "MTBCP", "MNOV", "MDSO", "MDGS", "MDWD", "MDVX", "MDVXW", "MEDP", "MEET", "MEIP", "MPEL", "MLNX", "MELR", "MEMP", "MENT", "MTSL", "MELI", "MBWM", "MERC", "MBVT", "MRCY", "EBSB", "VIVO", "MMSI", "MACK", "MSLI", "MRUS", "MLAB", "MESO", "CASH", "MBLX", "MEOH", "MFRI", "MGCD", "MGEE", "MGPI", "MCHP", "MU", "MICT", "MICTW", "MSCC", "MSFT", "MSTR", "MVIS", "MPB", "MTP", "MCEP", "MBRG", "MBCN", "MSEX", "MSBI", "MOFG", "MIME", "MDXG", "MNDO", "MB", "NERV", "MRTX", "MIRN", "MSON", "MIND", "MINDP", "MITK", "MITL", "MKSI", "MMAC", "MINI", "MOBL", "MOCO", "MDSY", "MLNK", "MBRX", "MNTA", "MOMO", "MCRI", "MDLZ", "MGI", "MPWR", "TYPE", "MNRO", "MRCC", "MNST", "MSDI", "MSDIW", "MHGC", "MORN", "MOSY", "MTFB", "MTFBW", "MPAA", "MDM", "MOXC", "MRVC", "MSBF", "MSG", "MTGE", "MTGEP", "MTSC", "LABL", "MFSF", "MYSZ", "MYL", "MYOK", "MYOS", "MYRG", "MYGN", "NBRV", "NAKD", "NNDM", "NANO", "NSTG", "NH", "NK", "NSSC", "NDAQ", "NTRA", "NATH", "NAUH", "NKSH", "FIZZ", "NCMI", "NCOM", "NGHC", "NGHCN", "NGHCO", "NGHCP", "NGHCZ", "NHLD", "NATI", "NRCIA", "NRCIB", "NSEC", "NWLI", "NAII", "NHTC", "NATR", "BABY", "NAVI", "NBTB", "NCIT", "NKTR", "NEOG", "NEO", "NEON", "NEOS", "NEOT", "NVCN", "NEPT", "UEPS", "NETE", "NTAP", "NTES", "NFLX", "NTGR", "NLST", "NTCT", "NTWK", "CUR", "NBIX", "NDRM", "NURO", "NUROW", "NYMT", "NYMTO", "NYMTP", "NLNK", "NWS", "NWSA", "NEWS", "NEWT", "NEWTL", "NEWTZ", "NXEO", "NXEOU", "NXEOW", "NXST", "NVET", "NFEC", "EGOV", "NICE", "NICK", "NCBS", "NIHD", "NVLS", "NMIH", "NNBR", "NDLS", "NDSN", "NSYS", "NBN", "NTIC", "NTRS", "NTRSP", "NFBK", "NRIM", "NWBI", "NWBO", "NWBOW", "NWPX", "NCLH", "NWFL", "NVFY", "NVMI", "NVDQ", "NOVN", "NOVT", "NVAX", "NVCR", "NVGN", "NUAN", "NMRX", "NTNX", "NUTR", "NTRI", "NUVA", "NVTR", "QQQX", "NVEE", "NVEC", "NVDA", "NXPI", "NXTM", "NXTD", "NXTDW", "NYMX", "OIIM", "OVLY", "OASM", "OBLN", "OBCI", "OPTT", "ORIG", "OSHC", "OCFC", "OCRX", "OCLR", "OFED", "OCUL", "OCLS", "OCLSW", "OMEX", "ODP", "OFS", "OHAI", "OVBC", "OHRP", "ODFL", "OLBK", "ONB", "OPOF", "OSBC", "OSBCP", "OLLI", "ZEUS", "OFLX", "OMER", "OMCL", "ON", "OTIV", "ONS", "ONSIW", "ONSIZ", "OGXI", "OMED", "ONTX", "ONTXW", "ONCS", "OHGI", "ONVI", "OTEX", "OPXA", "OPXAW", "OPGN", "OPGNW", "OPHT", "OPK", "OBAS", "OCC", "OPHC", "OPB", "ORMP", "OSUR", "ORBC", "ORBK", "ORLY", "OREX", "ONVO", "SEED", "OACQ", "OACQR", "OACQU", "OACQW", "OESX", "ORIT", "ORRF", "OFIX", "OSIS", "OSIR", "OSN", "OTEL", "OTIC", "OTTW", "OTTR", "OVAS", "OSTK", "OXBR", "OXBRW", "OXFD", "OXLC", "OXLCN", "OXLCO", "PFIN", "PTSI", "PCAR", "PACE", "PACEU", "PACEW", "PACB", "PCBK", "PEIX", "PMBC", "PPBI", "PAAC", "PAACR", "PAACU", "PAACW", "PCRX", "PACW", "PTIE", "PAAS", "PNRA", "PANL", "PZZA", "FRSH", "PBNC", "PRTK", "PRXL", "PCYG", "PSTB", "PKBK", "PRKR", "PKOH", "PARN", "PTNR", "PBHC", "PATK", "PNBK", "PATI", "PEGI", "PDCO", "PTEN", "PAVM", "PAVMW", "PAYX", "PCTY", "PYDS", "PYPL", "PBBI", "CNXN", "PCMI", "PCTI", "PDCE", "PDFS", "PDLI", "PDVW", "SKIS", "PGC", "PEGA", "PCO", "PENN", "PFLT", "PNNT", "PWOD", "PTXP", "PEBO", "PEBK", "PFBX", "PFIS", "PBCT", "PUB", "PRCP", "PPHM", "PPHMP", "PRFT", "PFMT", "PERF", "PERI", "PESI", "PTX", "PERY", "PGLC", "PETS", "PFSW", "PGTI", "PZRX", "PHII", "PHIIK", "PAHC", "PHMD", "PLAB", "PICO", "PIRS", "PPC", "PME", "PNK", "PNFP", "PPSI", "PXLW", "PLPM", "PLXS", "PLUG", "PLBC", "PSTI", "PBSK", "PNTR", "PCOM", "POOL", "POPE", "PLKI", "BPOP", "BPOPM", "BPOPN", "PBIB", "PTLA", "PBPB", "PCH", "POWL", "POWI", "PSIX", "DWLV", "DWIN", "DWTR", "IDLB", "PRFZ", "PAGG", "PSAU", "IPKW", "LDRI", "LALT", "PNQI", "PDBC", "QQQ", "USLB", "PSCD", "PSCC", "PSCE", "PSCF", "PSCH", "PSCI", "PSCT", "PSCM", "PSCU", "VRIG", "PRAA", "PRAH", "PRAN", "PFBC", "PLPC", "PFBI", "PINC", "LENS", "PRGX", "PSMT", "PBMD", "PNRG", "PRMW", "PRIM", "BTEC", "GENY", "PSET", "PY", "PSC", "PRZM", "PVTB", "PVTBP", "PDEX", "IPDN", "PFIE", "PGNX", "PRGS", "DNAI", "PFPT", "PRPH", "PRQR", "BIB", "UBIO", "TQQQ", "ZBIO", "SQQQ", "BIS", "PSEC", "PTGX", "PRTO", "PTI", "PRTA", "PVBC", "PROV", "PBIP", "PSDV", "PMD", "PTC", "PTCT", "PULM", "PLSE", "PCYO", "IMED", "FINQ", "PXS", "QADA", "QADB", "QCRH", "QGEN", "QIWI", "QLTI", "QRVO", "QCOM", "QSII", "QBAK", "QLYS", "QTNA", "QRHC", "QUIK", "QDEL", "QPAC", "QPACU", "QPACW", "QNST", "QUMU", "QUNR", "QTNT", "RRD", "RARX", "RADA", "RDCM", "ROIA", "ROIAK", "RSYS", "RDUS", "RDNT", "RDWR", "RMBS", "RAND", "RLOG", "GOLD", "RNDB", "RPD", "RAVE", "RAVN", "ROLL", "TALL", "RICK", "RCMT", "RDI", "RDIB", "RGSE", "RELY", "RNWK", "RP", "RETA", "DAX", "QYLD", "RCON", "REPH", "RRGB", "RRR", "RDHL", "REGN", "RGNX", "RGLS", "REIS", "RELV", "MARK", "RNST", "REGI", "RNVA", "RNVAZ", "RCII", "RTK", "RGEN", "RPRX", "RBCAA", "FRBK", "REFR", "RESN", "RECN", "ROIC", "SALE", "RTRX", "RVNC", "RVEN", "RVLT", "RWLK", "REXX", "RFIL", "RGCO", "RIBT", "RIBTW", "RELL", "RIGL", "NAME", "RNET", "RTTR", "RVSB", "RLJE", "RMGN", "ROBO", "FUEL", "RMTI", "RCKY", "RMCF", "ROKA", "ROSG", "ROST", "RBPAA", "RGLD", "RPXC", "RTIX", "RBCN", "RUSHA", "RUSHB", "RUTH", "RXII", "RYAAY", "STBA", "SANW", "SCAC", "SCACU", "SCACW", "SBRA", "SBRAP", "SABR", "SAEX", "SAFT", "SAGE", "SAIA", "SAJA", "SALM", "SAL", "SAFM", "SASR", "SGMO", "SANM", "GCVRZ", "SPNS", "SRPT", "SBFG", "SBFGP", "SBAC", "SCSC", "SMIT", "SCHN", "SCHL", "SCLN", "SGMS", "SNI", "SCYX", "SEAC", "SBCF", "STX", "SHIP", "SRSC", "SHLD", "SHLDW", "SHOS", "SPNE", "SGEN", "EYES", "SCWX", "SNFCA", "SEIC", "SLCT", "SCSS", "SIR", "SELB", "SIGI", "LEDS", "SMTC", "SENEA", "SENEB", "SNH", "SNHNI", "SNHNL", "SNMX", "SRTS", "SRTSW", "SQBG", "MCRB", "SREV", "SFBS", "SEV", "SVBI", "SGOC", "SMED", "SHSP", "SHEN", "SHLO", "TYHT", "SHPG", "SCVL", "SHBI", "SHOR", "SFLY", "SIFI", "SIEB", "SIEN", "BSRR", "SWIR", "SIFY", "SIGM", "SGMA", "SGNL", "SBNY", "SBNYW", "SLGN", "SILC", "SLAB", "SIMO", "SPIL", "SSRI", "SAMG", "SFNC", "SLP", "SINA", "SBGI", "SINO", "SVA", "SIRI", "SITO", "SKYS", "SKLN", "SPU", "SKYW", "SWKS", "ISM", "JSM", "OSM", "SLM", "SLMAP", "SLMBP", "SND", "SMBK", "SWHC", "SMSI", "SMTX", "LNCE", "SRAX", "SCKT", "SODA", "SOHU", "SLRC", "SUNS", "SEDG", "SONC", "SOFO", "SONS", "SPHS", "SORL", "SRNE", "SOHO", "SOHOB", "SOHOM", "SFBC", "SSB", "SFST", "SMBC", "SONA", "SBSI", "OKSB", "SP", "SPAN", "SBSA", "SGRP", "SPKE", "ONCE", "SPAR", "SPTN", "DWFI", "SPPI", "ANY", "SPEX", "SPI", "SAVE", "SPLK", "SPOK", "SPWH", "SBPH", "FUND", "SFM", "SPSC", "SSNC", "STAA", "STAF", "STMP", "STLY", "SPLS", "SBLK", "SBLKL", "SBUX", "STRZA", "STRZB", "STFC", "STBZ", "SNC", "STDY", "GASS", "STLD", "SMRT", "STLR", "STLRU", "STLRW", "SBOT", "STEM", "STML", "SRCL", "SRCLP", "STRL", "SHOO", "SSFN", "SYBT", "BANX", "SGBK", "SSKN", "SSYS", "STRT", "STRS", "STRA", "STRM", "SBBP", "STB", "SCMP", "SUMR", "SMMF", "SSBI", "SMMT", "SNBC", "SNHY", "SNDE", "SEMI", "SNSS", "STKL", "SPWR", "RUN", "SBCP", "SSH", "SUNW", "SMCI", "SPCB", "SCON", "SGC", "SUPN", "SPRT", "SGRY", "SCAI", "SRDX", "SBBX", "SIVB", "SIVBO", "SYKE", "SYMC", "SYNC", "SYNL", "SYNA", "SNCR", "SNDX", "SGYP", "SGYPU", "SGYPW", "ELOS", "SNPS", "SYNT", "SYMX", "SYUT", "SYPR", "SYRS", "SYRX", "TROW", "TTOO", "TRHC", "TCMD", "TAIT", "TTWO", "TLND", "TNDM", "TLF", "TNGO", "TANH", "TPIV", "TEDU", "TASR", "TATT", "TAYD", "TCPC", "AMTD", "TEAR", "TECD", "TCCO", "TTGT", "TGLS", "TGEN", "TNAV", "TTEC", "TLGT", "TENX", "GLBL", "TERP", "TRTL", "TRTLU", "TRTLW", "TVIA", "TBNK", "TSRO", "TESO", "TSLA", "TESS", "TSRA", "TTEK", "TTPH", "TCBI", "TCBIL", "TCBIP", "TCBIW", "TXN", "TXRH", "TFSL", "TGTX", "ABCO", "ANDE", "TBBK", "BONT", "CG", "CAKE", "CHEF", "TCFC", "DSGX", "DXYN", "ENSG", "XONE", "FINL", "FBMS", "FLIC", "GT", "HABT", "HCKT", "HAIN", "FITS", "CUBA", "INTG", "JYNT", "KEYW", "KHC", "OLD", "MDCO", "MIK", "MIDD", "NAVG", "SLIM", "STKS", "ORG", "PCLN", "PRSC", "BITE", "RMR", "SPNC", "TTD", "ULTI", "YORW", "NCTY", "TBPH", "TST", "TCRD", "THLD", "TICC", "TTS", "TIL", "TSBK", "TIPT", "TITN", "TTNP", "TIVO", "TMUS", "TMUSP", "TKAI", "TNXP", "TISA", "TOPS", "TORM          ", "TRCH", "TSEM", "TWER", "CLUB", "TOWN", "TPIC", "TCON", "TSCO", "TWMC", "TACT", "TRNS", "TBIO", "TGA", "TA", "TANNI", "TANNL", "TANNZ", "TZOO", "TRVN", "TCBK", "TRIL", "TRS", "TRMB", "TRIB", "TRIP", "TSC", "TBK", "TRNC", "TROV", "TROVU", "TROVW", "TRUE", "THST", "TRUP", "TRST", "TRMK", "TSRI", "TTMI", "TUBE", "TCX", "TUES", "TOUR", "HEAR", "TUTI", "TUTT", "FOX", "FOXA", "TWIN", "TRCB", "USCR", "PRTS", "USEG", "GROW", "UBNT", "UFPT", "ULTA", "UCTT", "RARE", "ULBI", "UTEK", "UMBF", "UMPQ", "UNAM", "UNIS", "UBSH", "UNB", "UNXL", "QURE", "UBCP", "UBOH", "UBSI", "UCBA", "UCBI", "UCFC", "UBNK", "UFCS", "UIHC", "UNFI", "UBFO", "USLM", "UTHR", "UG", "UNTY", "OLED", "UEIC", "UFPI", "ULH", "USAP", "UVSP", "UPLD", "URRE", "URBN", "ECOL", "USAT", "USATP", "USAK", "UTMD", "UTSI", "VALX", "VALU", "VNDA", "BBH", "GNRX", "PPH", "VWOB", "VNQI", "VGIT", "VCIT", "VIGI", "VYMI", "VCLT", "VGLT", "VMBS", "VNR", "VNRAP", "VNRBP", "VNRCP", "VONE", "VONG", "VONV", "VTWO", "VTWG", "VTWV", "VTHR", "VCSH", "VGSH", "VTIP", "BNDX", "VXUS", "VRNS", "VDSI", "VBLT", "VASC", "VBIV", "WOOF", "VECO", "DGLD", "DSLV", "UGLD", "USLV", "TVIZ", "TVIX", "ZIV", "XIV", "VIIZ", "VIIX", "APPY", "VRA", "VCYT", "VSTM", "VCEL", "VRNT", "VRSN", "VRSK", "VBTX", "VRML", "VSAR", "VTNR", "VRTX", "VRTB", "VIA", "VIAB", "VSAT", "VIAV", "VICL", "VICR", "CIZ", "CEZ", "CID", "CIL", "CFO", "CFA", "CSF", "CDC", "CDL", "CSB", "CSA", "VBND", "VUSE", "VIDI", "VDTH", "VRAY", "VKTX", "VKTXW", "VBFC", "VLGEA", "VIP", "VNOM", "VIRC", "VA", "VIRT", "VRTS", "VRTU", "VISN", "VTGN", "VTL", "VIVE", "VVUS", "VOD", "VLTC", "VOXX", "VYGR", "VSEC", "VTVT", "VUZI", "VWR", "WGBS", "WBA", "WAFD", "WAFDW", "WASH", "WFBI", "WSBF", "WVE", "WAYN", "WSTG", "WCFB", "WDFC", "FLAG", "WEB", "WBMD", "WCST", "WB", "WEBK", "WEN", "WERN", "WSBC", "WTBA", "WSTC", "WMAR", "WABC", "WBB", "WSTL", "WDC", "WNEB", "WLB", "WPRT", "WEYS", "WHLR", "WHLRD", "WHLRP", "WHLRW", "WHF", "WHFBL", "WFM", "WILN", "WHLM", "WVVI", "WVVIP", "WLDN", "WLFC", "WLTW", "WIN", "WINT", "WING", "WINA", "WINS", "WTFC", "WTFCM", "WTFCW", "AGND", "AGZD", "HYND", "HYZD", "CXSE", "EMCG", "EMCB", "DGRE", "DXGE", "WETF", "DXJS", "DXKW", "GULF", "CRDT", "DGRW", "DGRS", "DXPS", "UBND", "WIX", "WMIH", "WBKC", "WWD", "WKHS", "WRLD", "JMU", "WPCS", "WPPGY", "WMGI", "WMGIZ", "WSFS", "WSFSL", "WSCI", "WVFC", "WYNN", "XBIT", "XELB", "XCRA", "XNCR", "XBIO", "XBKS", "XENE", "XGTI", "XGTIW", "XLNX", "XOMA", "XPLR", "XTLB", "XNET", "YHOO", "YNDX", "YIN", "YRCW", "YECO", "YY", "ZFGN", "ZAGG", "ZAIS", "ZBRA", "ZLTQ", "Z", "ZG", "ZN", "ZNWAA", "ZION", "ZIONW", "ZIONZ", "ZIOP", "ZIXI", "ZGNX", "ZSAN", "ZUMZ", "ZYNE", "ZNGA"];

Tickers.prototype.ticker = function () {
    var length = Tickers.TICKERS.length;
    var index = Math.floor(Math.random() * length);
    return Tickers.TICKERS[index];
};

var tickers = new Tickers();
var lipsum = new LoremIpsum();

function getLipsum(num) {
    var phrase = lipsum.generate(num + 2);
    return phrase.substring(0, 1).toUpperCase() + phrase.substring(1);
}

function randomNumber(max, signed) {
    var val = Math.random() * max;
    if (signed) val *= Math.random() > 0.5 ? 1 : -1;
    return val;
}

function randomSignedNumber(max, negative) {
    var val = Math.random() * max;
    return val * (negative ? -1 : 1);
}

function randomArray(length, max) {
    var i = 0;
    var arr = [];
    var rnd = Math.random();
    var num, sign;

    if (rnd >= 0.2 && rnd < 0.7) {
        sign = true;
    } else if (rnd >= 0.7) {
        sign = false;
    }

    for (; i < length; i++) {
        if (typeof sign === "undefined") {
            num = randomNumber(max, true);
        } else {
            num = randomSignedNumber(max, !sign);
        }

        arr[i] = num;
    }

    return arr;
}

var scatterplot = {
    item: function item() {
        var ticker = tickers.ticker();
        return {
            totalReturn: randomNumber(20, true),
            standardDeviation: randomNumber(20, true),
            weight: randomNumber(100),
            ticker: ticker
        };
    },

    category: function category() {
        var arr = [];
        var num = Math.ceil(Math.random() * 5);
        var i = 0;
        for (; i < num; i++) {
            arr.push(scatterplot.item());
        }

        return {
            category: getLipsum(2),
            data: arr
        };
    },

    data: function data() {
        var dataset = [];
        var num = Math.ceil(Math.random() * 5) + 1;
        var i = 0;

        for (; i < num; i++) {
            dataset.push(scatterplot.category());
        }

        return {
            benchmark: {
                totalReturn: randomNumber(20, true),
                standardDeviation: randomNumber(20, true)
            },
            data: dataset
        };
    }
};

var barchart = {
    data: function data(howMany, maxValue) {
        var dataset = [];
        var num = Math.ceil(Math.random() * 5) + 1;
        var i = 0;
        howMany = howMany || 7;
        maxValue = maxValue || 100;

        for (; i < num; i++) {
            dataset.push(barchart.series(howMany, maxValue));
        }

        return dataset;
    },

    data2: function data2(howMany, maxValue) {
        var dataset = [];
        var num = Math.ceil(Math.random() * 5) + 1;
        var i = 0;
        howMany = howMany || 7;
        maxValue = maxValue || 100;

        for (; i < num; i++) {
            dataset.push({
                name: "Data " + (i + 1),
                values: randomArray(howMany, maxValue)
            });
        }

        return dataset;
    },

    series: function series(howMany, maxValue) {
        return {
            name: getLipsum(2),
            values: randomArray(howMany, maxValue)
        };
    },

    categories: function categories(prefix, num) {
        var arr = [];
        var i = 0;
        for (; i < num; i++) {
            arr[i] = prefix + " " + (i + 1);
        }

        return arr;
    },

    xlabels: function xlabels(num) {
        var i = 0;
        var arr = [];
        for (; i < num; i++) {
            if (Math.random() > 0.7) {
                arr[i] = getLipsum(1);
            } else {
                arr[i] = null;
            }
        }

        return arr;
    }
};

var getRandomDate = function getRandomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

var generateDates = function generateDates(range, amtOfDates) {
    var dates = [];

    var dateRange = void 0;
    switch (range) {
        case "hours":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 2));
            };
            break;
        case "days":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 6));
            };
            break;
        case "weeks":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 1, 28));
            };
            break;
        case "months":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 11, 1));
            };
            break;
        case "quarters":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2015, 0, 1), new Date(2016, 12, 31));
            };
            break;
        case "years":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2010, 0, 1), new Date(2016, 11, 0));
            };
            break;
        default:
            console.error("range required to generate dates");
            break;
    }

    for (var i = 0; i < amtOfDates; i++) {
        dates.push(dateRange());
    }

    return dates;
};

function getIncrementalValue(increment) {
    var positive = Math.floor(Math.random() * 2 + 1) === 1 ? false : true;

    if (positive) {
        return Math.floor(Math.random() * increment);
    } else {
        return -Math.floor(Math.random() * increment);
    }
}

//***** line chart *****/

var LineGenerator = function LineGenerator(dateRange) {
    this.leng = 50;
    this.dates = generateDates(dateRange, this.leng);
};

LineGenerator.prototype.generateDataset = function (opts) {
    return {
        y1: this.generateLineData(opts),
        y2: this.generateLineData(opts)
    };
};

LineGenerator.prototype.generateLineData = function (opts) {
    var groupName = Math.floor(Math.random() * 2 + 1) === 1 ? "y2" : "y1";
    var time = new Date();
    var name = time.getMilliseconds() + Math.floor(Math.random() * 999).toString();
    var segments = [];
    var currentValue = Math.floor(Math.random() + opts.minValue);

    for (var i = 0; i < opts.segments; i++) {
        var newValue;
        if (currentValue >= opts.maxValue || currentValue + opts.increment > opts.maxValue) {
            newValue = currentValue - opts.increment;
        } else {
            newValue = currentValue + getIncrementalValue(opts.increment);
        }

        segments.push({
            name: name,
            value: newValue,
            date: this.dates[i],
            groupName: groupName
        });
        currentValue = newValue;
    }
    return segments;
};

/**** end linechart */

module.exports = {
    ticker: tickers.ticker,
    lipsum: getLipsum,
    number: randomNumber,
    array: randomArray,
    scatterplot: scatterplot,
    barchart: barchart,
    getRandomDate: getRandomDate,
    generateDates: generateDates,
    linechart: LineGenerator,
    crmatrix: crmatrix
};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Calls a function if exists. The first argument should be the function to call followed by the arguments.
 *
 * @return {Object} Undefined if there is no function to call or what the function returns.
 */

var callFn = function callFn() {
    var args = Array.prototype.slice.call(arguments, 2);
    var context = arguments[0];
    var fn = arguments[1];

    if (fn) {
        return fn.apply(context, args);
    }
};

module.exports = {
    call: callFn
};

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    /**
     * Returns how many digits have a number.
     * @param {number} number Number to inspect. Rquired.
     * @param {Number} base Numeric base.
     * @returns {Number}
     */
    digits: function digits(number) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

        var digits = 0;

        while (number >= 1) {
            number = number / base;
            digits++;
        }

        return digits;
    },
    /**
    * @method isNumber
    * @desc Judge if a value is a valid number or a valid string number
    * @param literals value
    * Return Boolean
    */
    isNumber: function isNumber(value) {
        if (typeof value === "number" && isFinite(value)) {
            return true;
        }
        if (typeof value === "string" && value !== "" && !isNaN(value - 0)) {
            return true;
        }
        return false;
    }

};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CARDINAL_STR = "$$";

/**
 * It returns either the original value if zero or positive, or, if negative or NaN, the value with an em dash.
 *
 * @param {Number} A single number.
 * @return {Number || String} 10, "—10", "NaN", ...
 */
function convertDashToEnDash(val) {
    var stringed = val.toString();

    if (stringed === "NaN") {
        return "\u2013";
    }

    if (stringed[0] === "-") {
        var sliced = stringed.slice(1);
        sliced = "\u2013" + sliced;
        return sliced;
    }

    return val;
}
/**
 * Generates a Unique ID.
 * @returns {String} New unique ID.
 */
var UID = function UID() {
    return "_" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5));
};

/**
 * Converts a string in dashed format.
 *
 * @param {String} str String to convert.
 * @returns {String}
 */
function dashify(str) {
    str = str.replace(/\s+/g, "-").toLowerCase();
    return str;
}

/**
 * Compiles a string template agains a context and returns a new string.
 * <code>
 * var template =
 * 'My skills:' +
 * '<%if(this.showSkills) {%>' +
 *    '<%for(var index in this.skills) {%>' +
 *    '<a href="#"><%this.skills[index]%></a>' +
 *   '<%}%>' +
 * '<%} else {%>' +
 *    '<p>none</p>' +
 * '<%}%>';
 * console.log(TemplateEngine(template, {
 *    skills: ["js", "html", "css"],
 *    showSkills: true
 * }));
 * </code>
 * @param {String} html Template string.
 * @param {Object} data Context object that contains the data.
 * @returns {String}
 */
var template = function template(html, data) {
    var re = /<%([^%>]+)?%>/g;
    var reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;
    var code = "var r=[];\n";
    var cursor = 0;
    var match;

    var add = function add(line, js) {
        js ? code += line.match(reExp) ? line + "\n" : "r.push(" + line + ");\n" : code += line !== "" ? "r.push('" + line.replace(/"/g, "\\'") + "');\n" : ""; //jshint ignore:line
        return add;
    };

    match = re.exec(html);
    while (match) {
        add(html.slice(cursor, match.index))(match[1], true);
        cursor = match.index + match[0].length;
        match = re.exec(html);
    }

    add(html.substr(cursor, html.length - cursor));
    code += "return r.join('');";
    return new Function(code.replace(/[\r\t\n]/g, "")).apply(data); // jshint ignore:line
};

/**
 * Adds a prefix based on an index.
 *
 * @param {String} str
 * @param {Number} index
 * @returns {String}
 */
function mask(str, index) {
    return index + CARDINAL_STR + str;
}

/**
 * Remove index based prefix.
 *
 * @param {String} str
 * @returns {String}
 */
function unmask(str) {
    var indx = str.indexOf(CARDINAL_STR);
    return str.substr(indx + CARDINAL_STR.length);
}

/**
 * Get pixel with of string appended to the DOM
 *
 * @param {String} txt
 * @param {String} fontname = font family, e.g., "'MorningstarIntrinsic', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
 * @param {Number} fontsize, e.g., 16
 * @returns {String}
 */
function getTextWidth(txt, fontname, fontsize) {
    var e = document.createElement('span');
    e.style.fontSize = fontsize;
    e.style.fontFamily = fontname;
    e.innerHTML = txt;
    document.body.appendChild(e);
    var w = e.getBoundingClientRect().width;
    document.body.removeChild(e);
    return w;
}

/**
 * To get the pixel width of the longest string in the data set
 *
 * @param {String} txt
 * @param {String} fontname = font family, e.g., "'MorningstarIntrinsic', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
 * @param {Number} fontsize, e.g., 16
 * @returns {String}
 */
function getLongestTextStringWidth(data, font, size) {

    font = font || "'MorningstarIntrinsic', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif";
    size = size || 16;

    var longest = 0;
    var value;

    data.forEach(function (obj) {
        if (obj.value != null && obj.value.toString().length > longest) {
            longest = obj.value.toString().length;
            value = obj.value;
        }
    });

    var w = getTextWidth(value, font, size);
    return w;
}

module.exports = {
    convertDashToEnDash: convertDashToEnDash,
    dashify: dashify,
    template: template,
    UID: UID,
    mask: mask,
    unmask: unmask,
    getLongestTextStringWidth: getLongestTextStringWidth,
    getTextWidth: getTextWidth
};

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var object = __webpack_require__(3);

/**
 * Returns the path for a rounded rectangle.
 * @param {Number} x X position.
 * @param {Number} y Y position.
 * @param {Number} w Width.
 * @param {Number} h Heigth.
 * @param {Number} r Radius.
 * @param {Boolean} tl Top-Left.
 * @param {Boolean} tr Top-Right.
 * @param {Boolean} bl Bottom-Left.
 * @param {Boolean} br Bottom-Right.
 * @returns {String} Rounded Rectangle path.
 */
var roundedRect = function roundedRect(x, y, w, h, r, tl, tr, bl, br) {
    var result;
    result = "M" + (x + r) + "," + y;
    result += "h" + (w - 2 * r);
    if (tr) {
        result += "a" + r + "," + r + " 0 0 1 " + r + "," + r;
    } else {
        result += "h" + r;result += "v" + r;
    }

    result += "v" + (h - 2 * r);
    if (br) {
        result += "a" + r + "," + r + " 0 0 1 " + -r + "," + r;
    } else {
        result += "v" + r;result += "h" + -r;
    }

    result += "h" + (2 * r - w);
    if (bl) {
        result += "a" + r + "," + r + " 0 0 1 " + -r + "," + -r;
    } else {
        result += "h" + -r;result += "v" + -r;
    }

    result += "v" + (2 * r - h);
    if (tl) {
        result += "a" + r + "," + r + " 0 0 1 " + r + "," + -r;
    } else {
        result += "v" + -r;result += "h" + r;
    }

    result += "z";
    return result;
};

/**
 * Get an SVG Text width by adding it, getting the width and removing it.
 * @param {D3.Object} svgContainer Container where the text is gonna be attached.
 * @param {String} text Text to test width.
 * @return {Number} Calculated width.
 */
var getSVGTextWidth = function getSVGTextWidth(svgContainer, text, className) {
    var el = svgContainer.append("text").classed(className, true && className).text(text);
    var width = el.node().getBoundingClientRect().width;
    el.remove();
    return width;
};

/**
 * Get the longest String in pixels from a given array of data.
 * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
 * @param {Array} data Array containig the texts.
 * @param {String|Function}? accessor description
 */
var getGreaterSVGTextWidth = function getGreaterSVGTextWidth(svgContainer, data, accessor) {
    var greatest = 0;
    var text, width;
    data.forEach(function (item, i) {
        text = object.extract(item, accessor, i);
        width = getSVGTextWidth(svgContainer, text);
        greatest = width > greatest ? width : greatest;
    });

    return greatest;
};

/**
 * Get the total width of all Strings in pixels from a given array of data.
 * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
 * @param {Array} data Array containig the texts.
 * @param {String|Function}? accessor description
 */
var getTotalSVGTextWidth = function getTotalSVGTextWidth(svgContainer, data, accessor) {
    var total = 0;
    var width;
    data.forEach(function (item, i) {
        var dataName = item.__data__.displayName || item.__data__.name;
        width = getSVGTextWidth(svgContainer, dataName) + 15;
        if (item instanceof SVGElement) {
            var isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);
            width = item.getBoundingClientRect().width > width && !isSafari ? item.getBoundingClientRect().width : width;
        }
        total += width;
    });
    return total;
};

module.exports = {
    roundedRect: roundedRect,
    getSVGTextWidth: getSVGTextWidth,
    getGreaterSVGTextWidth: getGreaterSVGTextWidth,
    getTotalSVGTextWidth: getTotalSVGTextWidth
};

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * morningstar-base-charts
 *
 * Copyright © 2016 . All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
var mds_constants = __webpack_require__(7).constants;
var mds_chart_color = mds_constants["chart-color"];

module.exports = {
    colors: [mds_chart_color["1"], mds_chart_color["2"], mds_chart_color["3"], mds_chart_color["4"], mds_chart_color["5"], mds_chart_color["6"], mds_chart_color["7"]],
    canvasDefaults: {
        axesSpacing: 5,
        margin: { top: 20, right: 20, bottom: 20, left: 20 }
    }
};

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    // d3 overrides
    //----------------------------------

    d3.selection.prototype.first = function () {
        if (!this[0]) {
            return d3.select();
        }

        return d3.select(this[0][0]);
    };

    d3.selection.prototype.last = function () {
        if (!this[0]) {
            return d3.select();
        }

        var last = this.size() - 1;
        return d3.select(this[0][last]);
    };
    d3.selection.prototype.attrs = function (obj) {
        for (var attr in obj) {
            this.attr(attr, obj[attr]);
        }

        return this;
    };

    //---------------oOo-----------------
};

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    // Makes version of MBC available on window for debugging
    // VERSION is dynamically replaced as prebuild step
    window.mbc = {
        version: "2.17.1"
    };
};

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



// jscs:disable safeContextKeyword

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Utils = __webpack_require__(4);

/**
 * Base object. Provides a way to Class inheritance and use of mixins.
 *
 * @example {@lang javascript}
 *  // Simple extension.
 *
 *  // Creates a Person class extending from Base.
 *  var Person = Base.extend({
 *      name: "John",
 *      greet: function () { return "Hello, my name is" + this.get("name") + ".";}
 *  });
 *  var person = new Person();
 *  person.greet(); // "Hello, my name is John."
 *
 *  // Extending Person
 *  var Musician = Person.extend({
 *      name: "Wolfgang",
 *      instrument: "Violin",
 *      greet: function () { return this.__super__.greet.call(this) + " I play the " + this.get("instrument"); }
 *  });
 *
 *  var mozart = new Musician();
 *  mozart.greet()  // Hello, my name is Wolfgang. I play the Violin.
 *
 *  mozart.set("instrument", "Piano");
 *  mozart.greet()  // Hello, my name is Wolfgang. I play the Piano.
 * @example
 *  // Extension with mixins
 *
 *  // Mixin definition
 *  function DriverMixin () {}
 *  DriverMixin.prototype.drive = function() { return this.get("name") + "is driving a" + this.get("vehicle"); };
 *
 *  var Driver = Person.extend(DriverMixin, {
 *      vehicle: "Motorcycle"
 *  })
 *
 *  var juanPabloMontoya = new Driver();
 *
 *  juanPabloMontoya.drive(); // "John is driving a motorcycle"  <-- That's incorrect
 *  juanPabloMontoya.set("name", "Juan Pablo");
 *  juanPabloMontoya.set("vehicle", "Formula Car");
 *  juanPabloMontoya.drive(); // "Juan Pablo is driving a Formula Car"  <-- Now That's correct
 * @param {Object} options Class' instance attributes to be setted. Overrides existing ones or create a new attribute if it does not exist.
 * @constructor
 */
var Base = function Base() {};

Base.prototype = {
    __attributes: null,
    __watchers: null,
    /**
     * Sets the <i>value</i> under the passed <i>key</i> into the attributes's store.
     * @param {any} key Name of the attribute to store.
     * @param {any} value Attribute's value.
     * @returns {Base} object's instance to allow chainability.
     */
    set: function set(key, value) {
        this.__attributes[key] = value;
        this._checkWatcher(key, value);
        return this;
    },

    /**
     * Search the attribute's store and returns its value.
     * @param {any} key Attribute's key to retrieve.
     * @returns {Object} Attribute's value.
     */
    get: function get(key) {
        return this.__attributes[key];
    },

    /**
     * Initialize object attributes.
     */
    _initAttrs: function _initAttrs(options) {
        for (var key in options) {
            this.set(key, options[key]);
        }
    },

    /**
     * Set an attribute bound watcher.
     * @param {String} attribute Attribute's name.
     * @param {Function} handler Method to execute when the attribute changes.
     */
    watch: function watch(attribute, handler) {
        var watcher = this.__watchers[attribute];
        var handlers, length, value;

        if (watcher) {
            handlers = watcher.handlers;
            length = handlers.filter(function (fn) {
                return "" + fn === "" + handler;
            }).length;
            if (!length) {
                handlers.push(handler);
            }
        } else {
            value = this.__attributes ? this.__attributes[attribute] : undefined;
            this.__watchers[attribute] = {
                oldValue: value,
                handlers: [handler]
            };
        }
    },

    /**
     * Remove all handlers attached to an attribute key or just the one that contains the specified handler if it is passed as paramter
     * @param {String} attribute Attribute's name.
     * @param {Function} handler Optional. If not passed removes all handlers attached to the attribute.
     */
    unwatch: function unwatch(attribute, handler) {
        var watcher = this.__watchers[attribute];
        var handlers;

        if (watcher) {
            if (!handler) {
                delete this.__watchers[attribute];
            } else {
                handlers = watcher.handlers;
                handlers.splice(handlers.indexOf(handler), 1);
            }
        }
    },

    /**
     * Removes all attributes watchers.
     */
    unwatchAll: function unwatchAll() {
        this.__watchers = {};
    },

    /**
     * Checks if the attribute have been modified and execute the handler function.
     * @param {String} attribute Attribute's name.
     * @param {Object} newValue New attribute's value.
     */
    _checkWatcher: function _checkWatcher(attribute, newValue) {
        var watcher = this.__watchers[attribute];

        if (watcher && newValue !== watcher.oldValue) {
            watcher.handlers.forEach(function (handler) {
                handler(newValue, watcher.oldValue);
                watcher.oldValue = newValue;
            });
        }
    }

};

/**
 * Method that returns a new class extending the class that calls it. If mixins are
 * passed its methods are extended to the resultant class too.
 * @static
 * @returns {Class}
 */
Base.extend = function () {
    var properties = {};
    var mixins = [];
    var i = 0;
    var arg = arguments[i++];
    var parent = this;
    var parentDefaults = parent.prototype.__defaults__ || {};
    var defaults = {};
    var child, key, value;

    Utils.object.copy(defaults, parentDefaults);

    while ((typeof arg === "undefined" ? "undefined" : _typeof(arg)) !== "object") {
        mixins.push(arg);
        arg = arguments[i++];
    }

    properties = arg;

    child = function child(options) {
        parent.apply(this, arguments);

        this.__attributes = this.__attributes || {
            _id: new Date().getTime()
        };
        this.__watchers = {};
        for (key in this.__defaults__) {
            if (!this.__attributes[key]) {
                this.__attributes[key] = this.__defaults__[key];
            }
        }

        // Apply options
        if (options) {
            this._initAttrs(options);
        }

        if (properties.initializer && typeof properties.initializer === "function") {
            properties.initializer.call(this);
        }

        mixins.forEach(function (mixin) {
            if (mixin.prototype.initializer) {
                mixin.prototype.initializer.call(this);
            }
        }.bind(this));
    };

    // Copying statics from old class to new one.
    for (key in parent) {
        if (parent.hasOwnProperty(key)) {
            child[key] = parent[key];
        }
    }

    child.prototype = Object.create(parent.prototype);

    for (key in parent.prototype) {
        value = parent.prototype[key];
        if (typeof value !== "function") {
            if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
                defaults[key] = value;
            }
        }
    }

    // Adding/overwriting new properties into child prototype.
    if (properties) {
        for (key in properties) {
            if (properties.hasOwnProperty(key)) {
                value = properties[key];
                if (typeof value === "function") {
                    child.prototype[key] = value;
                } else if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
                    defaults[key] = value;
                }
            }
        }
    }

    mixins.forEach(function (mixin) {
        Utils.object.copy(child.prototype, mixin.prototype);
    });

    child.prototype.__defaults__ = Utils.object.clone(defaults);

    child.prototype.__super__ = parent.prototype;
    return child;
};

module.exports = Base;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = {"constants":{"color":{"white":"#ffffff","black":"#000000","neutral":{"12":"#1e1e1e","20":"#333333","37":"#5e5e5e","50":"#808080","67":"#ababab","80":"#cccccc","90":"#e5e5e5","95":"#f2f2f2"},"blue":{"23":"#004376","32":"#005ba1","36":"#006fba","38":"#1f55a5","41":"#0077cf","44":"#008dde"},"green":{"34":"#00af41"},"dark-green":{"34":"#518428"},"teal":{"19":"#005f5f"},"violet":{"46":"#6a4c9e"},"cyan":{"44":"#00a8e1"},"maroon":{"32":"#a50032"},"red":{"50":"#ff0000"},"yellow":{"48":"#f5c400"},"orange":{"54":"#ef7622"},"light-red":{"46":"#e60546"},"dark-violet":{"32":"#7d256f"},"dark-yellow":{"47":"#c19c31"},"aqua":{"37":"#00beaf"},"bright-orange":{"50":"#ff3c00"},"light-green":{"50":"#89bd40"}},"brand":{"blue":"#1f55a5","cyan":"#00a8e1"},"background-color":{"default":"#ffffff","light":"#f2f2f2","dark":"#1e1e1e","black":"#000000","alternative-row":{"default":"#e5e5e5","on-light":"#e5e5e5","on-dark":"#333333"},"feedback":{"error":"#ff0000","warning":"#f5c400"}},"text-color":{"primary":{"default":"#1e1e1e","on-light":"#1e1e1e","on-dark":"#ffffff"},"secondary":{"default":"#5e5e5e","on-light":"#5e5e5e","on-dark":"#ababab"},"link":{"default":"#006fba","on-light":"#006fba","on-dark":"#008dde"},"error":{"default":"#ff0000","on-light":"#ff0000","on-dark":"#ff0000"}},"interactive-color":{"primary":{"default":"#0077cf","hover":"#005ba1","focus":"#005ba1","active":"#004376"},"secondary":{"primary":"transparent","hover":"#5e5e5e","focus":"#5e5e5e","active":{"on-light":"#333333","on-dark":"#e5e5e5"}},"disabled":{"on-light":"#808080","on-dark":"#ababab"}},"visualization-color":{"asset-allocation":{"local-stocks":"#1f55a5","non-local-stocks":"#8faad2","stocks":"#1f55a5","real-estate":"#a50032","other":"#f5c400","cash":"#518428","bonds":"#ef7622","not-classified":"#e5e5e5"},"correlation":{"positive":"#1f55a5","negative":"#ef7622"},"sector":{"cyclical":"#ef7622","sensitive":"#1f55a5","defensive":"#518428"},"sustainability":"#1f55a5","valuation":{"under":"#00a8e1","fair":"#e5efef","over":"#ef7622"},"performance":{"positive":"#00af41","neutral-text":"#5e5e5e","neutral-chart":"#cccccc","negative":"#ff0000"}},"chart-color":{"1":"#1f55a5","2":"#a50032","3":"#f5c400","4":"#518428","5":"#00a8e1","6":"#6a4c9e","7":"#ef7622","8":"#005f5f","9":"#00af41","10":"#e60546","11":"#7d256f","12":"#c19c31","13":"#00beaf","14":"#ff3c00","15":"#89bd40"},"feedback-color":{"info":"#f2f2f2","error":"#ff0000","error-background":"#ffe5e5","warning":"#f5c400","warning-background":"#fef9e5","success":"#00af41","success-background":"#e5f7eb"},"font":{"family":{"sans-serif":"'MorningstarIntrisic', HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif","monospace":"'Lucida Sans Typewriter', 'Lucida Console', monaco, 'Bitstream Vera Sans Mono', monospace"},"weight":{"thin":200,"light":300,"regular":400,"bold":600},"size":{"xs":"10px","s":"14px","m":"16px","l":"20px","base":"16px","default":"16px","heading-level-1":"45px","heading-level-2":"32px","heading-level-3":"28px","heading-level-4":"23px","heading-level-5":"20px","heading-level-6":"18px","code":"12px"},"line-height":{"headings":1.2,"body":1.375}},"border":{"separator":{"default":"solid 1px #e5e5e5","on-light":"solid 1px #cccccc","on-dark":"solid 1px #333333","on-title":"solid 2px #333333","color-on-light":"#cccccc","color-on-dark":"#333333"},"control":{"default":"solid 1px #808080","color":"#808080"},"container":{"default":"solid 1px #e5e5e5","color-default":"#e5e5e5"},"disabled":"solid 1px #808080","radius":{"panel":"12px","pill":"24px","round":"50%","s":"2px"}},"size":{"icon":{"s":"15px","m":"23px"}},"space":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","inset":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","stretch":{"s":"6px 12px","m":"8px 16px","l":"12px 24px"}},"inline-left":{"xs":"0 4px 0 0","s":"0 6px 0 0","m":"0 8px 0 0","l":"0 12px 0 0","xl":"0 16px 0 0","half-x":"0 4px 0 0","three-quarter-x":"0 6px 0 0","1-x":"0 8px 0 0","1-and-a-half-x":"0 12px 0 0","2-x":"0 16px 0 0"},"inline-right":{"xs":"0 0 0 4px","s":"0 0 0 6px","m":"0 0 0 8px","l":"0 0 0 12px","xl":"0 0 0 16px","half-x":"0 0 0 4px","three-quarter-x":"0 0 0 6px","1-x":"0 0 0 8px","1-and-a-half-x":"0 0 0 12px","2-x":"0 0 0 16px"},"stack":{"s":"0 0 6px","m":"0 0 8px","l":"0 0 12px","xl":"0 0 16px","quarter-x":"0 0 2px","half-x":"0 0 4px","three-quarter-x":"0 0 6px","1-x":"0 0 8px","1-and-a-half-x":"0 0 12px","2-x":"0 0 16px","3-x":"0 0 24px","4-x":"0 0 32px","8-x":"0 0 64px"}},"transition":{"color":{"link":"color, 300ms"}},"opacity":{"disabled":".4","overlay":".5"},"box-shadow":{"drop":"0 2px 4px 0 rgba(0, 0, 0, .08)","focus":"0 0 4px 2px rgba(#0077cf, .8)"},"z-index":{"low":1,"sticky":100,"modal-overlay":800,"modal-content":810,"top-of-the-world":900},"breakpoint":{"navigation":{"on-canvas-nav":"768px","wide":"1024px"}},"masthead":{"height":"50px","height-tall":"70px"},"site-navigation":{"height":"50px","vertical-width":"230px"}},"shared":[{"utils":true},{"color":true},{"fonts":true},{"accessibility":true},{"animation":true},{"size":true},{"bubbles":true},{"typography":true}],"components":[{"link":true},{"icon":true},{"button":true},{"button_group":true},{"card":true},{"navigation_container":true},{"container":true},{"data_table":true},{"dialog":true},{"form":true},{"combo_box":true},{"list_group":true},{"loader":true},{"modal":true},{"menu":true},{"notification":true},{"pagination":true},{"page_shell":true},{"popover":true},{"range_slider":true},{"search_field":true},{"stepper":true},{"switch":true},{"tag":true},{"tooltip":true},{"masthead":true},{"site_navigation":true},{"alert":true},{"top_hat":true},{"layout_grid":true}],"theme":"mds"}

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BASE = "mbc";
var CHART = BASE + "-chart";

module.exports = {
    AXES: BASE + "-axes",
    AXIS: BASE + "-axis",
    BACK: BASE + "-back-group",
    CANVAS: BASE + "-canvas",
    CHART_GROUP: CHART + "-group",
    CHART: CHART,
    CHARTS_AREA: CHART + "s-area",
    CONTAINER: CHART + "-container",
    DECK: CHART + "-deck",
    FOCUS: CHART + "-focus",
    FRONT: BASE + "-front-group",
    GRID: BASE + "-grid",
    GRID_LINE: BASE + "-grid-line",
    INNER: CHART + "-inner",
    LAYERS: BASE + "-layers",
    LEGEND_ITEM: CHART + "-legend-item",
    LEGEND: CHART + "-legend",
    TITLE: CHART + "-title",
    TOOLTIP: CHART + "-tooltip",
    TOOLTIP_CONTAINER: CHART + "-tooltip-container",
    ZONES: CHART + "-zones",
    ZONE: CHART + "-zone"
};

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates an AxesManager instance. AxesManagers centralize chart's axes
 * in order to access them transversely.<br>
 * @example
 * var axesManager = new AxesManager({"x", d3.svg.axis()})
 * @constructor
 * @param {object} axes <i>Optional</i>. A hashmap with chart's axes.
 */

function AxesManager(axes) {
    this._axes = axes || {};
}
/**
 * Sets or returns an axis. If no axis object is passsed then sets the axis.
 * @param  {String} axisName
 * @param  {D3.axis} axis
 *
 * @return {D3.axis}
 */
AxesManager.prototype.axis = function (axisName, axis) {
    if (!axisName) {
        return;
    }

    if (!axis) {
        return this._axes[axisName];
    }

    this._axes[axisName] = axis;
    return axis;
};

/**
 * Remove an axis from the collection.
 * @param {String} axisName Axis to remove.
 */
AxesManager.prototype.remove = function (axisName) {
    delete this._axes[axisName];
};

/**
 * Return the axes store object.
 *
 * @returns {Object} Hashmap that containing the axes.
 */
AxesManager.prototype.axes = function () {
    return this._axes;
};

module.exports = AxesManager;

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});